import React, { useState, useRef, useEffect, useCallback } from 'react';
import CustomEdge, { EdgeProvider } from './CustomEdge';
import PublishContainer from './publishContainer';

import BarChart from './components/BarChart';
import LineChart from './components/LineChart';
import PieChart from './components/PieChart';
import ScatterChart from './components/ScatterChart';
import BoxWhiskerChart from './components/BoxWhiskerChart';
import DoughnutChart from './components/DoughnutChart';
import ErrorPopup from './validation/ErrorPopup'; // Replace with the correct path to your ErrorPopup component
import errorPopup from './css/errorPopup.css'; // Replace with the correct path to your ErrorPopup component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'react-router-dom';

import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls, Handle,
  ArrowHeadType, Position,
  removeElements, useStoreState,
  useStoreActions, useReactFlow,
  getConnectedEdges, Background, MarkerType,
  EdgeTypes
} from 'reactflow';
//import {useStoreState, removeElements } from 'react-flow-chart';

import 'reactflow/dist/style.css';

import SqlEditorPopupComponent from './PopUpWindows/sqlEditorPopupComponent';
import CreateTablePopupComponent from './PopUpWindows/createTablePopupComponent';
import DataTablePopupComponent from './PopUpWindows/dataTablePopupComponent';
import SortPopupComponent from './PopUpWindows/sortPopupComponent';
import FilterPopupComponent from './PopUpWindows/filterPopupComponent';
import JoinPopupComponent from './PopUpWindows/joinPopupComponent';
import SummarizePopupComponent from './PopUpWindows/summarizePopupComponent';
import GroupByPopupComponent from './PopUpWindows/groupByPopupComponent';
import AppendPopupComponent from './PopUpWindows/appendPopupComponent';
import ExtractPopupComponent from './PopUpWindows/extractPopupComponent';
import LineChartPopupComponent from './PopUpWindows/lineChartPopupComponent';
import BarChartPopupComponent from './PopUpWindows/barChartPopupComponent';
import PieChartPopupComponent from './PopUpWindows/pieChartPopupComponent';
import ScatterChartPopupComponent from './PopUpWindows/scatterChartPopupComponent';
import BoxWhiskerChartPopupComponent from './PopUpWindows/boxWhiskerChartPopupComponent';
import HeatMapChartPopupComponent from './PopUpWindows/heatMapChartPopupComponent';


import {
  barPopupContent, piePopupContent,
  linePopupContent, scatterPopupContent
} from './PopUpWindows/popupContent';


/*  Call tokens */
import {
 readEachReportData, createNewReport,
  generateSqlQuery, generateSQLData, createNewChartReport, generateSqliteQueryResponse
} from './authorization/FetchToken';
import TableGrid from './grid/DataTableGrid';
import Sidebar from './Sidebar';
import Navbar from './components/Navbar';
import Draggable from './Draggable';
import databaseicon from './images/db.png';
import databaseicondrop from './images/datatablerightcontainer.png';
import sortIconDrop from './images/sortright.png';
import sorticon from './images/sort.png';
import filtericon from './images/filter.png';
import filterIconDrop from './images/filterRight.png';
import joinicon from './images/join.png';
import summarizeicon from './images/summarize.png';
import selecticon from './images/select.png';
import appendicon from './images/append.png';
import extracticon from './images/extract.png';
import linecharticon from './images/linechart.png';
import barcharticon from './images/barchart.png';
import piecharticon from './images/piechart.png';
import scattercharticon from './images/scatter1.png';
import boxWhiskercharticon from './images/scatter1.png';
import heatMapcharticon from './images/scatter1.png';
import DroppedNode from './PopUpWindows/DroppedNode';
import './index.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Spinner from './Spinner'; // Import the Spinner component

let nodeId = 1;
let execSqlStatement = false;
let filterTableValueSame = true;

const QueryBuilder = () => {
  console.log("gridddata-1::")

  const location = useLocation();
  const navigate = useNavigate();


  // show catalogs
  const [dropdownCatalogs, setDropdownCatalogs] = useState([]);

  // show schemas
  const [dropdownSchemas, setDropdownSchemas] = useState([]);


  // show tables
  const [dropdownTables, setDropdownTables] = useState([]);

  // show tables
  const [dropdownColumns, setDropdownColumns] = useState([]);

  // Access the data (formData, connectionId, and name) from the location state
  //const { formData } = location.state || {};

  const eachReportDetails = location.state;// This is the data you sent through navigation

  let catalogs = [];
  let schemas = [];
  let tables = [];
  let columns = [];
  //let isSelectedWindowFunctionChecked=false
  //const [isSelectedWindowFunctionChecked, setIsSelectedWindowFunctionChecked] = useState('');
  const [isSelectedWindowFunction, setIsSelectedWindowFunction] = useState({});
  const [windowFunctionsList, setWindowFunctionsList] = useState([]); 

  if (location.state !== null) {
    const { catalogs, schemas, tables, columns } = location.state;
  }


  let connectionNameValue = '';
  let reportNameValue = '';
  let connectionTypeValue = '';
  console.log("gridddata-1.5::")
  const [gridData, setGridData] = useState([]);
  const [gridDataColumns, setGridDataColumns] = useState([]);
  console.log("gridddata-1.75::")
  if (eachReportDetails && eachReportDetails.connectionName) {
    console.log("gridddata-1.9::")
    connectionNameValue = eachReportDetails.connectionName;
    reportNameValue = eachReportDetails.reportName;
    connectionTypeValue = eachReportDetails.connectionType;

    console.log(JSON.stringify(eachReportDetails) + "LOCATION");
    console.log(JSON.stringify(connectionTypeValue) + "connectionTypeValue");
    console.log(JSON.stringify(location.state) + "location.state");
    console.log(JSON.stringify(eachReportDetails.connectionName) + "connectionName");
    console.log(JSON.stringify(eachReportDetails.reportName) + "connectionName");
    console.log(JSON.stringify(connectionNameValue) + "connectionNameValue");
    console.log(JSON.stringify(eachReportDetails.catalogs) + "catalogs");


  }
  
  const onNodesDelete = useCallback((deleted) => {console.log("NodeDelete:11:")})

  const [nodeName, setNodeName] = useState('');
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [showCharts, setShowCharts] = useState(false);
  const [deletedIndex, setDeletedIndex] = useState(null); // or useState(undefined)
  const [reportName, setReportName] = useState([]);
  const [reportDescription, setReportDescription] = useState([]);
  const [reportDetails, setReportDetails] = useState([]);
  const [reportNameError, setReportNameError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formBarSubmitted, setFormBarSubmitted] = useState(false);
  const [formLineSubmitted, setFormLineSubmitted] = useState(false);
  const [formScatterSubmitted, setFormScatterSubmitted] = useState(false);

  const [formBoxWhiskerSubmitted, setFormBoxWhiskerSubmitted] = useState(false);
  const [formHeatMapSubmitted, setFormHeatMapSubmitted] = useState(false);
  const [formDataTableSubmitted, setFormDataTableSubmitted] = useState(false);
  const [sqlQuery, setSqlQuery] = useState();
  const [sqlDirectQuery, setSqlDirectQuery] = useState();
  const [selectedSqlQuery, setSelectedSqlQuery] = useState();


  const [selectedElements, setSelectedElements] = useState([]);
  const [selectedEdgeId, setSelectedEdgeId] = useState(null);


  //datatablenode griddata
  console.log("gridddata-2::")
  //const [gridData, setGridData] = useState([]);
  //const [gridDataColumns, setGridDataColumns] = useState([]);
  console.log("gridddata-3::")
  // Charts parameters for Piecharts
  const [selectedCombinedColumns, setSelectedCombinedColumns] = useState('');
  const [selectedIdsCombinedColumns, setSelectedIdsCombinedColumns] = useState('');
  const [selectedLabelType, setSelectedLabelType] = useState('');
  const [indexPie, setIndexPie] = useState(0);
  const [xandLabelPieColumns, setXandLabelPieColumns] = useState('');


  //Barchart params

  const [selectedCombinedBarColumns, setSelectedCombinedBarColumns] = useState('');
  const [verticalLabel, setVerticalLabel] = useState('');
  const [horizantalLabel, setHorizantalLabel] = useState('');
  const [barRightList, setBarRightList] = useState('');
  const [xandLabelBarColumns, setXandLabelBarColumns] = useState('');

  //Linechart params

  const [selectedCombinedLineColumns, setSelectedCombinedLineColumns] = useState('');
  const [verticalLineLabel, setVerticalLineLabel] = useState('');
  const [horizantalLineLabel, setHorizantalLineLabel] = useState('');
  const [lineRightList, setLineRightList] = useState('');
  const [dataTableDroppedNodes, setDataTableDroppedNodes] = useState([]);
  const [xandLabelLineColumns, setXandLabelLineColumns] = useState([]);

  //Scatter chart params
  const [selectedCombinedScatterColumns, setSelectedCombinedScatterColumns] = useState('');
  const [verticalScatterLabel, setVerticalScatterLabel] = useState('');
  const [horizantalScatterLabel, setHorizantalScatterLabel] = useState('');
  const [scatterRightList, setScatterRightList] = useState('');
  const [xandLabelScatterColumns, setXandLabelScatterColumns] = useState('');

  //BoxWhisker chart params
  const [selectedCombinedBoxWhiskerColumns, setSelectedCombinedBoxWhiskerColumns] = useState('');
  const [verticalBoxWhiskerLabel, setVerticalBoxWhiskerLabel] = useState('');
  const [horizantalBoxWhiskerLabel, setHorizantalBoxWhiskerLabel] = useState('');
  const [boxWhiskerRightList, setBoxWhiskerRightList] = useState('');

  //HeatMap chart params
  const [selectedCombinedHeatMapColumns, setSelectedCombinedHeatMapColumns] = useState('');
  const [verticalHeatMapLabel, setVerticalHeatMapLabel] = useState('');
  const [horizantalHeatMapLabel, setHorizantalHeatMapLabel] = useState('');
  const [HeatMapRightList, setHeatMapRightList] = useState('');

  // piechart for combine columns

  const [twoTableColumnsCombined, setTwoTableColumnsCombined] = useState([]);

  // SQLJSONDATA to save 
  const [sqlJsonData, setSqlJsonData] = useState([]);

  //spinner
  const [loading, setLoading] = useState(false);

  //validation popup
  const [isSaved, setIsSaved] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [error, setError] = useState(''); // Error message state
  const [showErrorPopup, setShowErrorPopup] = useState(false); // Error popup visibility state


  const [highlightedText, setHighlightedText] = useState('');


  let nodeId = 0; // Initialize the node ID counter


  const nodesTypesRightContainer = [
    {
      id: 'sqlEditor',
      type: 'input',
      alt: 'sqlEditor',
      icon: databaseicon,
      label: 'sql Editor'

    },
    {
      id: 'createTable',
      type: 'output',
      alt: 'createTable',
      icon: databaseicon,
      label: 'create Table',
      sourcePosition: 'left',
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },

    },
    {
      id: 'dataTable',
      type: 'input',
      alt: 'dataTable',
      icon: databaseicon,
      sourcePosition: 'right',
      label: 'Data Table',
      edges: ['right'],
      maxConnections: 2,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Right,
      },
    },
    {
      id: 'sort',
      label: 'Sort',
      type: 'default',

      alt: 'sort',
      icon: sorticon,
      sourcePosition: 'right',
      targetPosition: 'left',
      edges: ['right', 'left'],
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'filter',
      label: 'Filter',
      type: 'default',
      alt: 'filter',
      icon: filtericon,
      sourcePosition: 'right',
      targetPosition: 'left',
      edges: ['right', 'left'],
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },

    {
      id: 'join',
      label: 'Join',
      type: 'default',
      alt: 'join',
      icon: joinicon,
      sourcePosition: 'right',
      targetPosition: 'left',
      edges: ['right', 'left'],
      maxConnections: 2,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'summarize',
      label: 'Summarize',
      type: 'default',
      alt: 'Summarize',
      icon: summarizeicon,
      edges: ['right', 'left'],
      sourcePosition: 'right',
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'groupBy',
      label: 'GroupBy',
      type: 'default',
      alt: 'GroupBy',
      icon: selecticon,
      edges: ['right', 'left'],
      maxConnections: 1,
      sourcePosition: 'right',
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'append',
      label: 'Append',
      type: 'default',
      alt: 'Append',
      icon: appendicon,
      edges: ['right', 'left'],
      maxConnections: 1,
      sourcePosition: 'right',
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'extract',
      label: 'Extract',
      type: 'default',
      alt: 'Extract',
      icon: extracticon,
      edges: ['right', 'left'],
      maxConnections: 1,
      sourcePosition: 'right',
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Right,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },

    {
      id: 'bar',
      label: 'Bar',
      type: 'output',
      alt: 'Bar',
      icon: barcharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'line',
      label: 'Line',
      type: 'output',
      alt: 'Line Chart',
      icon: linecharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      maxConnections: 1,
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'pie',
      label: 'Pie',
      type: 'output',
      alt: 'Pie Chart',
      icon: piecharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'scatter',
      label: 'Scatter',
      type: 'output',
      alt: 'Scatter',
      icon: scattercharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },
    },
    {
      id: 'boxWhisker',
      label: 'boxWhisker',
      type: 'output',
      alt: 'boxWhisker',
      icon: boxWhiskercharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },

    },
    {
      id: 'heatMap',
      label: 'heatMap',
      type: 'output',
      alt: 'heatMap',
      icon: heatMapcharticon,
      edges: ['left'],
      maxConnections: 1,
      targetPosition: 'left',
      sourceHandle: {
        id: 'sourceHandle',
        position: Position.Left,
      },
      targetHandle: {
        id: 'targetHandle',
        position: Position.Left,
      },

    },
    // Add more nodes with their respective edges
  ];


  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  // Combine nodes and edges into the elements array
  const [elements, setElements] = useState([...nodes, ...edges]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  const [connections, setConnections] = useState([]); // Array to store connections
  const [sources, setSources] = useState([]); // Array to store source nodes
  const [targets, setTargets] = useState([]);

  const [rightSources, setRightSources] = useState([]);
  const [leftTargets, setLeftTargets] = useState([]);

  // Array to store connected nodes on the left edge
  const [rightTargets, setRightTargets] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(false);
  const [droppedNodes, setDroppedNodes] = useState([]);
  const [nodeData, setNodeData] = useState({}); // State to store individual node data

  const [sqlArray, setSqlArray] = useState([]);
  const [edgeTypeButton, setEdgeTypesButton] = useState('AND');
  const [data, setData] = useState([]);

  const [selectedDatabase, setSelectedDatabase] = useState('');
  const [selectedTable, setSelectedTable] = useState('');
  const [selectedColumn, setSelectedColumn] = useState('');
  const [columnTypes, setColumnTypes] = useState('');
  const [popupDropdownValues, setPopupDropdownValues] = useState([]);
  // const [elements, setElements] = useState([]);

  const [toggleStates, setToggleStates] = useState({});

  const fetchEditReportConnections = async (connectionName) => {
    let data;
    try {
      const reportData = await readEachReportData(
        eachReportDetails.connectionName,
        eachReportDetails.reportName,
        localStorage.getItem('orgName')
      );

      console.log("READ EACH REPORT DATA : " + JSON.stringify(reportData));


      // Handle the response data from listStateFiles
      console.log(reportData); // You should see the list of connections in the console
      console.log(JSON.stringify(reportData) + "UPDATEDDATA---");
      console.log(JSON.stringify(reportData.nodeData) + "NODDEDATA--");
      if (reportData && reportData.reportName) {
        setReportName(reportData.reportName);
      }
      if (reportData && reportData.droppedNodes) {

        const drop = reportData.droppedNodes;
        console.log(drop + "drop");
        setDroppedNodes(drop);

      }
      if (reportData && reportData.reportDescription) {
        setReportDescription(reportData.reportDescription);
      }
      if (reportData && reportData.nodes) {

        setNodes(reportData.nodes);

      }

      if (reportData && reportData.edges) {
        setEdges(reportData.edges);
        const edgesMatchingPie = reportData.edges.filter((edge) => edge.target.includes("pie"));

        if (edgesMatchingPie.length > 0) {

        }
      }
      if (reportData && reportData.nodeData) {
        setNodeData(reportData.nodeData);
        // Get the keys of the data.nodeData object
        const nodeDataKeys = Object.keys(reportData.nodeData);

        const edgesMatchingPie = nodeDataKeys.filter((edge) => edge.includes("pie"));
        const edgesMatchingBar = nodeDataKeys.filter((edge) => edge.includes("bar"));
        const edgesMatchingLine = nodeDataKeys.filter((edge) => edge.includes("line"));
        const edgesMatchingScatter = nodeDataKeys.filter((edge) => edge.includes("scatter"));
        if (edgesMatchingPie.length > 0) {

          /*  important ocde for maintain the piechart */
          const pieChartFields = edgesMatchingPie.map(key => reportData.nodeData[key]);

          console.log("Edges matching 'pie':", pieChartFields);
          setFormSubmitted(false);
          setSelectedCombinedColumns(pieChartFields[0].selectedCombinedColumns);
          setSelectedIdsCombinedColumns(pieChartFields[0].selectedIdsCombinedColumns);
          setSelectedLabelType(pieChartFields[0].selectedLabelType);
          setXandLabelPieColumns(pieChartFields[0].selectedColumnsCombined);


        }
        if (edgesMatchingBar.length > 0) {

          /*  important ocde for maintain the barchart */
          const barChartFields = edgesMatchingBar.map(key => reportData.nodeData[key]);

          console.log("Edges matching 'bar':", barChartFields);
          setSelectedCombinedBarColumns(barChartFields[0].selectedCombinedColumns);
          setVerticalLabel(barChartFields[0].verticalLabel);
          setHorizantalLabel(barChartFields[0].horizantalLabel);
          setBarRightList(barChartFields[0].rightList);
          setXandLabelBarColumns(barChartFields[0].selectedColumnsCombined);

          setFormSubmitted(false);
          setFormBarSubmitted(false);
          setFormScatterSubmitted(false);
        }
        if (edgesMatchingLine.length > 0) {

          /*  important ocde for maintain the barchart */
          const lineChartFields = edgesMatchingLine.map(key => reportData.nodeData[key]);

          console.log("Edges matching 'line':", lineChartFields);
          setSelectedCombinedLineColumns(lineChartFields[0].selectedCombinedColumns);
          setVerticalLineLabel(lineChartFields[0].verticalLabel);
          setHorizantalLineLabel(lineChartFields[0].horizantalLabel);
          setLineRightList(lineChartFields[0].rightList);
          setXandLabelLineColumns(lineChartFields[0].selectedColumnsCombined);

          setFormSubmitted(false);
          setFormBarSubmitted(false);
          setFormScatterSubmitted(false);
        }
        if (edgesMatchingScatter.length > 0) {

          /*  important ocde for maintain the barchart */
          const scatterChartFields = edgesMatchingScatter.map(key => reportData.nodeData[key]);

          console.log("Edges matching 'scatter':", scatterChartFields);
          setSelectedCombinedScatterColumns(scatterChartFields[0].selectedCombinedColumns);
          setVerticalScatterLabel(scatterChartFields[0].verticalLabel);
          setHorizantalScatterLabel(scatterChartFields[0].horizantalLabel);
          setScatterRightList(scatterChartFields[0].rightList);
          setXandLabelScatterColumns(scatterChartFields[0].selectedColumnsCombined);

          setFormSubmitted(false);
          setFormBarSubmitted(false);
          setFormLineSubmitted(false);
        }

      }


    } catch (error) {
      console.error('Error fetching connections:', error);
    }
  };

  useEffect(() => {

  }, [selectedNodeId]);


  useEffect(() => {
    // Call the fetchConnections function when the component mounts
    fetchEditReportConnections(connectionNameValue);
    console.log(JSON.stringify(connectionNameValue) + "connectionName");

  }, [connectionNameValue]);

  useEffect(() => {
    if (droppedNodes.length > 0) {
      console.log(JSON.stringify(droppedNodes) + "FINALVALUE");

    }
  }, [droppedNodes]);


  useEffect(() => {

    if (eachReportDetails && eachReportDetails.reportName) {
      setReportName(eachReportDetails.reportName || []);
    } else {
      setReportName('');
    }
    if (eachReportDetails && eachReportDetails.reportDescription) {
      setReportDescription(eachReportDetails.reportDescription || []);
    } else {
      setReportDescription('');
    }
    if (eachReportDetails && eachReportDetails.nodes) {
      setNodes(eachReportDetails.nodes);
    } else {
      setNodes([]);
    }
    if (eachReportDetails && eachReportDetails.edges) {
      setEdges(eachReportDetails.edges);
    } else {
      setEdges([]);
    }
    if (eachReportDetails && eachReportDetails.droppedNodes) {
      setDroppedNodes(eachReportDetails.droppedNodes);
    } else {
      setDroppedNodes([]);
    }


    //    setDroppedNodes(formData.droppedNodes || []);
  }, [eachReportDetails]);

  // Simulate fetching data from an API
  const fetchDropdownValues = () => {
    setDropdownCatalogs(location.state.catalogs);
    setDropdownSchemas(location.state.schemas);
    setDropdownTables(location.state.tables);
    setDropdownColumns(location.state.columns);

    console.log(JSON.stringify(dropdownCatalogs) + "---"
      + JSON.stringify(dropdownSchemas) + "--" + JSON.stringify(dropdownTables) + "--" + JSON.stringify(dropdownColumns) + "allvalues");

  };

  useEffect(() => {
    if (location.state && location.state.catalogs && location.state.schemas &&
      location.state.tables && location.state.columns) {
      fetchDropdownValues();
    } else {
      setDropdownCatalogs([]);
      setDropdownSchemas([]);
      setDropdownTables([]);
      setDropdownColumns([]);
    }
  }, [location.state]);



  // Function to update the dynamic value
  const handleReportNameChange = (event) => {
    const newReportName = event.target.value;
    setReportName(newReportName);
    setReportNameError(''); // Reset the error message
  };
  // Function to update the dynamic value
  const handleReportDescriptionChange = (event) => {
    const newReportDescription = event.target.value;
    setReportDescription(newReportDescription);
  };

  const handleToggleValue = (edgeId, newState) => {
    const updatedToggleStates = {
      ...toggleStates,
      [edgeId]: newState,
    };

    setToggleStates(updatedToggleStates);

    // Rest of the code...
  };

  const [edgeButtonValues, setEdgeButtonValues] = useState({});

  const handleButtonValueChange = (edgeId, value) => {

    setEdgeButtonValues((prevValues) => ({
      ...prevValues,
      [edgeId]: value,
    }));
    console.log(JSON.stringify(edgeButtonValues) + "edgeButtonValues");
  };


  const getDropdownValues = (selectedNode) => {
    let dropdownValues = {};
    console.log(JSON.stringify(selectedNode));
    if ((selectedNode.id).match(/^dataTable/)) {
      console.log("selectedDataTableNode::11")
      
      // Get the selected database and table names
      const selectedDatabaseName = selectedNode.data.database;
      const selectedTableName = selectedNode.data.table;
      // Find the selected database from the data
      const selectedDatabase = data.databases.find((db) => db.name === selectedDatabaseName);

      if (selectedDatabase) {
        // Find the selected table from the selected database
        const selectedTable = selectedDatabase.tables.find((table) => table.name === selectedTableName);

        if (selectedTable) {
          // Extract the columns of the selected table
          const columns = selectedTable.columns;

          // Add the database name, table name, and columns to the dropdown values
          dropdownValues.database = selectedDatabaseName;
          dropdownValues.table = selectedTableName;
          dropdownValues.columns = columns;
        }
      }
    }

    return dropdownValues;
  };






  const addConnection = (sourceNodeId, targetNodeId) => {
    const sourceNode = nodes.find((node) => node.id === sourceNodeId);
    const targetNode = nodes.find((node) => node.id === targetNodeId);

    if (sourceNode && targetNode) {
      if (!sourceNode.connections || !Array.isArray(sourceNode.connections)) {
        sourceNode.connections = []; // Initialize the connections array
      }
      if (!targetNode.connections || !Array.isArray(targetNode.connections)) {
        targetNode.connections = []; // Initialize the connections array
      }

      const existingSourceConnections = sourceNode.connections.length;
      const existingTargetConnections = targetNode.connections.length;



      const newConnection = {
        source: sourceNodeId,
        target: targetNodeId,
      };


      sourceNode.connections.push(newConnection);


      // Perform any other necessary actions when adding a connection

      console.log(`Connection added: ${JSON.stringify(newConnection)}`);
      console.log(`Total connections for source node: ${sourceNode.connections.length}`);
    }
  };

  const [submittedValue, setSubmittedValue] = useState('');



  const handleCreateTableSubmit = (onClose, jsonCreateTableData, isTableDropdownExists,
    catalogDropdown, schemaDropdown, tableDropdownNotSqlite,
    fileFormatTypeValue, chunkSize,
    ifTableExists, loadTableListNotSqliteOptions,
    loadTableList) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              onClose, jsonCreateTableData, isTableDropdownExists,
              catalogDropdown, schemaDropdown,
              fileFormatTypeValue, chunkSize,
              ifTableExists, loadTableListNotSqliteOptions,
              loadTableList, tableDropdownNotSqlite

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {

        onClose, jsonCreateTableData, isTableDropdownExists,
        catalogDropdown, schemaDropdown,
        fileFormatTypeValue, chunkSize,
        ifTableExists, loadTableListNotSqliteOptions,
        loadTableList, tableDropdownNotSqlite

      },
    }));
  };


  const handleCreateTableSqliteSubmit = (onClose, jsonCreateTableData, isTableDropdownExists,
    schemaSqliteDropdown, tableDropdown,
    fileFormatTypeValue, chunkSize,
    ifTableExists, loadTableListNotSqliteOptions) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              onClose, jsonCreateTableData, isTableDropdownExists,
              schemaSqliteDropdown, tableDropdown,
              fileFormatTypeValue, chunkSize,
              ifTableExists, loadTableListNotSqliteOptions
            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {

        onClose, jsonCreateTableData, isTableDropdownExists,
        schemaSqliteDropdown, tableDropdown,
        fileFormatTypeValue, chunkSize,
        ifTableExists, loadTableListNotSqliteOptions

      },
    }));
  };


  const handleSqlEditorSubmit = (selectedNodeId, name, catalog,
    selectedDatabase, selectedTable,
    columns, leftList, rightList,
    catalogDataList, schemaDataList,
    tableDataList, columnDataList, initialCatalogList, initialSchemaList,
    initialTableList, initialColumnList,
    columnTypeListValue, text, selectedText,
    selectedFieldsFromEditor, editorCatalog, editorSchema, editorTable) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              catalog: catalog,
              selectedDatabase: selectedDatabase,
              // selectedTable: selectedTable,
              columns: columns,
              columnTypes: columnTypes,
              selectedTable: selectedTable,
              // selectedTable: {
              //   ...selectedTable,
              //   selectedDatabase: selectedDatabase
              // },
              rightList,
              leftList,
              catalogDataList,
              schemaDataList,
              tableDataList,
              columnDataList,
              initialCatalogList, initialSchemaList,
              initialTableList, initialColumnList,
              columnTypeListValue,
              isSaved,
              // aliasColumnNames,
              // aliasFunctionNames,
              sql: text,
              selectedSql: selectedText,
              selectedFieldsFromEditor,
              editorCatalog, editorSchema, editorTable
            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        catalog,
        selectedDatabase,
        selectedTable,
        // selectedTable: {
        //   ...selectedTable,
        //   selectedDatabase: selectedDatabase
        // },
        columns,
        columnTypes,
        rightList,
        leftList,
        catalogDataList,
        schemaDataList,
        tableDataList,
        columnDataList,
        columnTypeListValue,
        isSaved,
        // aliasColumnNames,
        // aliasFunctionNames,
        sql: text,
        selectedSql: selectedText,
        selectedFieldsFromEditor, editorCatalog, editorSchema, editorTable
      },
    }));
    setSelectedNodeId(selectedNodeId);
    setFormDataTableSubmitted(true);
    setShowPopup(false);
    // setSqlQuery(text);
    setSqlQuery(selectedText);
    setSelectedSqlQuery(selectedText);

  };

  const handleDataTableSubmit = (selectedNodeId, name, catalog,
    selectedDatabase, selectedTable,
    columns, leftList, formattedLeftList, rightList,
    selectedWindowFunction, selectedNestedWindowFunction,appendWindowFunction,
    selectedTableColumns, orderBy, partitionBy, showWindowFunction,
    selectedAdditionalWindowFunction,
    selectedAdditionalNestedWindowFunction,
    showAdditionalGroupInputsLength,
    selectedAdditionalCounts,
    additionalSelectedTableColumns,
    additionalOrderBy,
    additionalPartitionBy,
    selectedCount, ntileValue,
    ntileAdditionalValue, catalogDataList, schemaDataList,
    tableDataList, columnDataList, initialCatalogList, initialSchemaList,
    initialTableList, initialColumnList, columnTypeListValue, isSaved,
    aliasColumnNames, aliasFunctionNames, windowFunctionWithCondition,
    aliasColumnsAndTypes, columnsWithCatalogs, isFilterTableValueSame, isSelectedWindowFunction, windowFunctionsList) => {
    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      console.log("setDataTableNode::1", orderBy)
      //isSelectedWindowFunctionChecked = isSelectedWindowFunctionChecked
      setIsSelectedWindowFunction(isSelectedWindowFunction)
      setWindowFunctionsList(windowFunctionsList)
      console.log("buildelect::-4.95", isSelectedWindowFunction, windowFunctionsList)
      filterTableValueSame = isFilterTableValueSame
      console.log("isFilterTableValueSame::3", isFilterTableValueSame, filterTableValueSame)
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              catalog: catalog,
              selectedDatabase: selectedDatabase,
              // selectedTable: selectedTable,
              columns: columns,
              columnTypes: columnTypes,
              selectedTable: selectedTable,
              // selectedTable: {
              //   ...selectedTable,
              //   selectedDatabase: selectedDatabase
              // },
              rightList,
              leftList,
              selectedWindowFunction,
              selectedNestedWindowFunction,
              appendWindowFunction,
              selectedTableColumns,
              orderBy,
              partitionBy,
              showWindowFunction,
              selectedAdditionalWindowFunction,
              selectedAdditionalNestedWindowFunction,
              showAdditionalGroupInputsLength,
              selectedAdditionalCounts,
              additionalSelectedTableColumns,
              additionalOrderBy,
              additionalPartitionBy,
              selectedCount,
              ntileValue, ntileAdditionalValue,
              catalogDataList,
              schemaDataList,
              tableDataList,
              columnDataList,
              initialCatalogList, initialSchemaList,
              initialTableList, initialColumnList,
              columnTypeListValue,
              isSaved,
              aliasColumnNames,
              aliasFunctionNames,
              windowFunctionWithCondition,
              aliasColumnsAndTypes,
              formattedLeftList,
              columnsWithCatalogs,
              isFilterTableValueSame,
              isSelectedWindowFunction,
              windowFunctionsList
            },
            // Set the desired label for the node
          };
        }
        return node;
      });
      return updatedNodes;
      //setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        catalog,
        selectedDatabase,
        selectedTable,
        columns,
        columnTypes,
        rightList,
        leftList,
        selectedWindowFunction,
        appendWindowFunction,
        selectedTableColumns,
        orderBy,
        partitionBy,
        showWindowFunction,
        selectedAdditionalWindowFunction,
        selectedAdditionalNestedWindowFunction,
        showAdditionalGroupInputsLength,
        selectedAdditionalCounts,
        additionalSelectedTableColumns,
        additionalOrderBy,
        additionalPartitionBy,
        selectedCount, ntileValue, ntileAdditionalValue,
        catalogDataList,
        schemaDataList,
        tableDataList,
        columnDataList,
        columnTypeListValue,
        isSaved,
        aliasColumnNames,
        aliasFunctionNames,
        windowFunctionWithCondition,
        aliasColumnsAndTypes,
        formattedLeftList,  
        columnsWithCatalogs,
        isFilterTableValueSame,
        isSelectedWindowFunction,
        windowFunctionsList
      },
    }));
    console.log("setDataTableNode::", orderBy, selectedAdditionalWindowFunction, selectedAdditionalNestedWindowFunction,JSON.stringify(nodes))
    setSelectedNodeId(selectedNodeId);
    setFormDataTableSubmitted(true);
    setShowPopup(false);
   /*
    console.log("nodes::11",JSON.stringify(nodes))
    nodes.map((node) => {
      if (node.id == selectedNodeId) {
        console.log("setDataTableNode::3", node.connections)
        node.connections.map((n) =>
          nodes.map((n2) => {
            if (n2.id == n.target) {
              console.log("setDataTableNode::4", JSON.stringify(n2.data))
              
            }
          })
        )
      }
    });
    */

  };

  const handleSortSubmit = (selectedNodeId, name, buildOrderBy, selectedTable, selectedColumns, isChecked,
    thenByIsChecked,
    selectedThenByColumns, showAdditionalinputlength) => {
    console.log(showAdditionalinputlength + "showAdditionalinputlength");
    console.log(JSON.stringify(selectedColumns) + "selectedColumnsSORTSUBMIT");
    console.log(selectedColumns + "selectedColumns" + selectedThenByColumns + "--selectedThenByColumns");
    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          //   const buildOrderBy = [selectedColumns,selectedThenByColumns];
          // alert(JSON.stringify(buildOrderBy)+"buildOrderBySORTSUBMIT");
          return {
            ...node,
            data: {
              ...node.data,
              label: name,

              // selectedDatabase: node.data.selectedDatabase, // Maintain the selectedDatabase value
              // selectedTable: node.data.selectedTable,
              buildOrderBy,
              selectedTable,
              selectedColumns,
              isChecked,
              thenByIsChecked,
              selectedThenByColumns,
              showAdditionalinputlength
            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        buildOrderBy,
        selectedTable,
        selectedColumns,
        isChecked,
        thenByIsChecked,
        selectedThenByColumns,
        showAdditionalinputlength
        //   selectedDatabase: node.data.selectedDatabase, // Maintain the selectedDatabase value
        // selectedTable: node.data.selectedTable,
      },
    }));
    setFormDataTableSubmitted(false);
    setShowPopup(false);
  };

  const handleFilterSubmit = (selectedNodeId, name, compareType, selectedTable,
    selectedFilterColumns, enterValue, enterSecondValue, additionalTextboxValues, selectedGroupColumns, additionalCompareType,
    showAdditionalinputGrouplength, additionalLogicalOperators, dataFilterJson, filterColumn) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      console.log("querySelectedFilterColumns::1", selectedFilterColumns)
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {

          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              compareType,
              selectedTable,
              selectedFilterColumns,
              selectedGroupColumns,
              additionalCompareType,
              showAdditionalinputGrouplength,
              enterValue,
              enterSecondValue,
              additionalTextboxValues,
              additionalLogicalOperators,
              dataFilterJson,
              filterColumn
            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);
    console.log("querySelectedFilterColumns::11", selectedFilterColumns)
    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        compareType,
        selectedTable,
        selectedFilterColumns,
        additionalCompareType,
        showAdditionalinputGrouplength,
        selectedGroupColumns,
        enterValue,
        enterSecondValue,
        additionalTextboxValues,
        additionalLogicalOperators,
        dataFilterJson,
        filterColumn
      },
    }));

    setShowPopup(false);
  };



  const handlePieSubmit = (selectedNodeId, name,
    selectedCombinedColumns, selectedIdsCombinedColumns,
    selectedLabelType, selectedColumnsCombined) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {

          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedCombinedColumns,
              selectedIdsCombinedColumns,
              selectedLabelType,
              selectedColumnsCombined

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedCombinedColumns,
        selectedIdsCombinedColumns,
        selectedLabelType,
        selectedColumnsCombined
      },
    }));

    setShowPopup(false);
    setSelectedCombinedColumns(selectedCombinedColumns);
    setSelectedIdsCombinedColumns(selectedIdsCombinedColumns);
    setSelectedLabelType(selectedLabelType);
    setSelectedNodeId(selectedNodeId);
    //setIndexPie(columnLabelIndexValue);
    setXandLabelPieColumns(selectedColumnsCombined);
  };


  const handleBarSubmit = (selectedNodeId, name, selectedCombinedColumns,
    leftList, rightList, verticalLabel, horizantalLabel, selectedCurrentTable,
    selectedColumnsCombined) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          //   const buildOrderBy = [selectedColumns,selectedThenByColumns];
          // alert(JSON.stringify(buildOrderBy)+"buildOrderBySORTSUBMIT");
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedCombinedColumns,
              leftList,
              rightList,
              verticalLabel,
              horizantalLabel,
              selectedCurrentTable,
              selectedColumnsCombined

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedCombinedColumns,
        leftList,
        rightList,
        verticalLabel,
        horizantalLabel,
        selectedCurrentTable,
        selectedColumnsCombined
      },
    }));

    setSelectedCombinedBarColumns(selectedCombinedColumns);
    setVerticalLabel(verticalLabel);
    setHorizantalLabel(horizantalLabel);
    setBarRightList(rightList);
    setShowPopup(false);
    setXandLabelBarColumns(selectedColumnsCombined);
  };


  const handleLineSubmit = (selectedNodeId, name, selectedCombinedColumns,
    leftList, rightList, verticalLabel, horizantalLabel, selectedCurrentTable, selectedColumnsCombined) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          //   const buildOrderBy = [selectedColumns,selectedThenByColumns];
          // alert(JSON.stringify(buildOrderBy)+"buildOrderBySORTSUBMIT");
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedCombinedColumns,
              leftList,
              rightList,
              verticalLabel,
              horizantalLabel,
              selectedCurrentTable,
              selectedColumnsCombined

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedCombinedColumns,
        leftList,
        rightList,
        verticalLabel,
        horizantalLabel,
        selectedCurrentTable,
        selectedColumnsCombined
      },
    }));


    setSelectedCombinedLineColumns(selectedCombinedColumns);
    setVerticalLineLabel(verticalLabel);
    setHorizantalLineLabel(horizantalLabel);
    setLineRightList(rightList);
    setShowPopup(false);
    setFormLineSubmitted(true);
    setFormDataTableSubmitted(false);
    setXandLabelLineColumns(selectedColumnsCombined);
  };

  const handleScatterSubmit = (selectedNodeId, name, selectedCombinedColumns,
    leftList, rightList, verticalLabel, horizantalLabel, selectedCurrentTable, selectedColumnsCombined) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          //   const buildOrderBy = [selectedColumns,selectedThenByColumns];
          // alert(JSON.stringify(buildOrderBy)+"buildOrderBySORTSUBMIT");
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedCombinedColumns,
              leftList,
              rightList,
              verticalLabel,
              horizantalLabel,
              selectedCurrentTable,
              selectedColumnsCombined

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedCombinedColumns,
        leftList,
        rightList,
        verticalLabel,
        horizantalLabel,
        selectedCurrentTable,
        selectedColumnsCombined
      },
    }));

    setSelectedCombinedScatterColumns(selectedCombinedColumns);
    setVerticalScatterLabel(verticalLabel);
    setHorizantalScatterLabel(horizantalLabel);
    setScatterRightList(rightList);
    setShowPopup(false);
    setFormScatterSubmitted(true);
    setFormDataTableSubmitted(false);
    setXandLabelScatterColumns(selectedColumnsCombined);
  };

  const handleBoxWhiskerSubmit = (selectedNodeId, name, selectedCombinedColumns,
    leftList, rightList, verticalLabel, horizantalLabel) => {

    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {

          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedCombinedColumns,
              leftList,
              rightList,
              verticalLabel,
              horizantalLabel

            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    // setNodeName(name);
    // setSelectedOption(option);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedCombinedColumns,
        leftList,
        rightList,
        verticalLabel,
        horizantalLabel
      },
    }));


    setSelectedCombinedBoxWhiskerColumns(selectedCombinedColumns);
    setVerticalBoxWhiskerLabel(verticalLabel);
    setHorizantalBoxWhiskerLabel(horizantalLabel);
    setBoxWhiskerRightList(rightList);
    setShowPopup(false);
    setFormBoxWhiskerSubmitted(true);
    setFormDataTableSubmitted(false);

  };

  const handleGroupBySubmit = (selectedNodeId, name, selectedAliasFunctionColumns,
    selectedRightlistColumns, selectedLeftListColumns, selectedCurrentTable) => {
    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              selectedRightlistColumns,
              selectedLeftListColumns,
              selectedCurrentTable,
              selectedAliasFunctionColumns
            },
            // Set the desired label for the node
          };
        }
        return node;
      });

      return updatedNodes;
      setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        selectedRightlistColumns,
        selectedLeftListColumns,
        selectedCurrentTable,
        selectedAliasFunctionColumns
      },
    }));

    setShowPopup(false);
  };

  const handleJoinSubmit = (selectedNodeId, name, joinType, compareType, datatableListOne,
    datatableListTwo,
    datatableOne,
    datatableTwo, buildJoin,
    additionalLogicalOperators,
    additionalColumnOneValues,
    additionalColumnTwoValues,
    showAdditionalColumnslength, additionalCompareTypeValues) => {

    console.log("datatableListTwo::2", selectedNodeId, name, joinType, compareType, datatableListOne,
      datatableListTwo,
      datatableOne,
      datatableTwo);
    
    setNodes((nodes) => {
      // Map over the nodes array and update the label for the desired node
      const updatedNodes = nodes.map((node) => {
        if (node.id === selectedNodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              label: name,
              joinType,
              compareType,
              datatableListOne,
              datatableListTwo,
              datatableOne,
              datatableTwo,
              buildJoin,
              additionalLogicalOperators,
              additionalColumnOneValues,
              additionalColumnTwoValues,
              showAdditionalColumnslength,
              additionalCompareTypeValues
            },
            // Set the desired label for the node
          };
        }
        console.log("setJoinNode::1", node.id, selectedNodeId, JSON.stringify(node))
        return node;
      });
      console.log("setJoinNode::2", JSON.stringify(nodes))
      return updatedNodes;
      //setNodes((nodes) => nodes.concat(updatedNodes));
    }, [reactFlowInstance]);

    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        joinType,
        compareType,
        datatableListOne,
        datatableListTwo,
        datatableOne,
        datatableTwo,
        buildJoin,
        additionalLogicalOperators,
        additionalColumnOneValues,
        additionalColumnTwoValues,
        showAdditionalColumnslength,
        additionalCompareTypeValues
      },
    }));

    setShowPopup(false);
  };

  const onNodeDoubleClick = (event, node) => {
    setSelectedNode(node);
  };

  function getConnectedEdgesCount(nodeId, edges) {
    return edges.filter((edge) => edge.source === nodeId || edge.target === nodeId).length;
  }

  const isJoinNode = (nodeId) => {
    return nodeId.startsWith('join');
  };


  // const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);
  const onConnect = (event) => {

    const { source, target } = event;
    console.log(event);
    const sourceHandle = 'right';
    const targetHandle = 'left';
    const sourceId = event.source; // Extract the source ID
    const targetId = event.target; // Extract the target ID

    // Access the IDs as needed
    console.log('Source ID:', sourceId);
    console.log('Target ID:', targetId);


    const sourceNode = nodes.find((node) => node.id === source);
    const targetNode = nodes.find((node) => node.id === target);

    console.log(JSON.stringify(sourceNode) + "sourceNode");
    console.log(JSON.stringify(targetNode) + "targetNode");


    const sourceNodeID = sourceNode.id;
    const sourceNodeIDSplit = sourceNodeID.split("_");
    const targetNodeID = targetNode.id;
    const targetNodeIDSplit = targetNodeID.split("_");

    // Check if the connection is valid
    if (source && target && source !== target) {

      // Call the addConnection function to add the connection
      addConnection(source, target);
    }

    // Extract source and target arrays
    const sourceArray = edges.map(connection => connection.source);
    const targetArray = edges.map(connection => connection.target);
    console.log(JSON.stringify(edges) + "***********" + JSON.stringify(sourceArray) + "***********" + JSON.stringify(targetArray));


    const joinCount = targetArray.filter(target => target.includes("join")).length;
    console.log(joinCount);

    const isSourceConnected = edges.some((connection) => connection.source === source);
    const isTargetConnected = edges.some((connection) => connection.target === target);



    const requiredConnections = 2;
    const joinNodes = targetArray.filter(target => target.includes("join"));
    console.log(joinNodes, joinNodes);

    const joinNodeConnectionsCount = {};

    for (const joinNode of joinNodes) {
      const connectionsCount = targetArray.filter(target => target === joinNode).length;
      joinNodeConnectionsCount[joinNode] = connectionsCount;
    }

    const hasRequiredConnections = joinNodes.every(joinNode => joinNodeConnectionsCount[joinNode] >= requiredConnections);


    //const hasRequiredConnections = joinNodes.every(joinNode => targetArray.filter(target => target === joinNode).length >= requiredConnections);

    //const hasRequiredConnections = targetArray.filter(target => target === joinNode).length >= requiredConnections;

    console.log(isSourceConnected + "--" + isTargetConnected);
    if (isSourceConnected || isTargetConnected && hasRequiredConnections) {

      // Source node already has a connection, do not create a new connection
      return;
    } else {

      if (isTargetConnected && targetNodeIDSplit[0] !== "join") {
        return;
      } else {

        const isSourceFilterNode = sourceNode.alt === 'filter';
        const isTargetFilterNode = targetNode.alt === 'filter';

        let edgeType = 'defaultEdge';
        let buttonValue = '';
        if (isSourceFilterNode && isTargetFilterNode) {
          edgeType = 'customEdge';
          // buttonValue = 'AND';
        }


        const newEdge = {
          id: `e${source}-${target}`, // a unique ID for the edge
          source,
          sourceHandle: 'right', // you can set this if you have multiple source handles
          target,
          targetHandle: 'left', // you can set this if you have multiple target handles
          type: edgeType, // set your own custom edge type if needed
          animated: true, // set to false if you don't want the edge to animate
          // set the label for the edge
          style: { stroke: '#ccc', strokeWidth: 2 }, // set the style for the edge
          // set the arrowhead type for the edge
          sourcePosition: 'right',
          targetPosition: 'left',
          markerEnd: {
            type: MarkerType.Arrow,
          },
          //  buttonValue: 'AND', 
          initialEdgeType: 'AND',

          onToggle: handleToggleValue,

        };

        console.log(JSON.stringify(newEdge));

        const updatedEdges = [...edges, newEdge]; // Create a new array with existing edges and the new edge

        setEdges(updatedEdges); // Update the state with the new edges

        setEdges([...edges, newEdge]);

        console.log(JSON.stringify(updatedEdges) + "updatedEdgesupdatedEdges");
        console.log(JSON.stringify(nodes) + "NODESONCONNECT");
        console.log(JSON.stringify(edges) + "EDGESONCONNECT");
      }

      // }
    }


    console.log(JSON.stringify(edges) + "ALL THE EDGES AVAILABLE HERE");
  };

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);


  // Callback function to update nodes in the parent component
  const updateNodes = (updatedNodes) => {
    setNodes(updatedNodes);
  };

  // Callback function to update dropped nodes in the parent component
  const updateDroppedNodes = (droppedNodes) => {
    setDroppedNodes(droppedNodes);
  };


  const idCounters = {}; // Object to store separate counters for each node type
  let id = 1;
  const getId = (selectedEachNodeType) => {
    if (!idCounters[selectedEachNodeType]) {
      idCounters[selectedEachNodeType] = 1; // Initialize the counter if it doesn't exist
    }
    // const id = `${selectedEachNodeType}_${idCounters[selectedNodeType]++}`;
    // return id;
    return `${selectedEachNodeType}_${idCounters[selectedEachNodeType]++}`;
  };

  const onDrop = useCallback(
    (event, selectedEachNodeType) => {

      event.preventDefault();
      console.log("droppedNodes123::1",JSON.stringify(nodes));

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData('application/reactflow');
      const icon = event.dataTransfer.getData('image/icon');


      // check if the dropped element is valid
      if (typeof type === 'undefined' || !type) {
        return;
      }


      const nodeType = event.dataTransfer.getData('application/reactflow');
      const iconUrl = event.dataTransfer.getData('image/icon');
      const draggedId = event.dataTransfer.getData('id');
      const positionSourceNode = event.dataTransfer.getData('positionSource');
      const positionTargetNode = event.dataTransfer.getData('positionTarget');




      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      // Find the node type object from the nodeTypes array based on the nodeType value
      const selectedNodeType = nodesTypesRightContainer.find((node) => node.id === draggedId);
      console.log(JSON.stringify(draggedId) + "NODETYPES");
      console.log(JSON.stringify(selectedNodeType) + "selectedNodeType");
      const selectedEachNodeId = selectedNodeType.id;
      const selectedDatabaseNames = dropdownSchemas;
      const initialDatabase = dropdownSchemas[0];

      const initialTable = dropdownTables.map(table => table[0]);
      const initialColumn = dropdownColumns.map(column => column[0]);
      const columnTypes = dropdownColumns.map((column) => column[1]);

      console.log(columnTypes);
      console.log(JSON.stringify(droppedNodes) + "droppedNodes1234");

      // Generate a unique ID for the dropped node based on its type
      let generatedEachNodeId = getId(selectedEachNodeId);


      let lastIndex = 0;
      let lastNode = "";
      // Check if the generated ID already exists in the droppedNodes array
      if (droppedNodes.includes(generatedEachNodeId)) {


        // To Find the last node in the droppedNodes array with the same node ID
        for (let i = droppedNodes.length - 1; i >= 0; i--) {

          const node = droppedNodes[i];
          if (node.startsWith(selectedEachNodeId + "_")) {
            const lastNodeParts = node.split('_');
            lastIndex = parseInt(lastNodeParts[lastNodeParts.length - 1]);
            break;
          }
        }

        // Increment the numeric part by 1 to get the new index
        const newIndex = lastIndex + 1;

        // Generate the new ID with the incremented index
        generatedEachNodeId = `${selectedEachNodeId}_${newIndex}`;
      }

      const newNode = {
        id: generatedEachNodeId,
        type: selectedNodeType.type,
        position,
        // icon,
        alt: selectedNodeType.alt,
        data: {
          // label: `${selectedNodeType.label} `,
          label: `${generatedEachNodeId} `,
          labelPosition: 'bottom', // set the label position to bottom
          labelBgPadding: [6, 6], // set the padding for the label background
          labelStyle: { fontSize: '12px' },
          url: iconUrl,
        },


        style: {
          backgroundImage: `url(${iconUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain', // set the size of the image
          backgroundPosition: 'center', // position the image at the center of the node
        },
        sourcePosition: selectedNodeType.sourcePosition,
        targetPosition: selectedNodeType.targetPosition,
        handles: {
          left: {
            position: 'right',
            type: 'target',
            isConnectable: false,
            // id: `${getId()}-left`,
          },
          right: {
            position: 'left',
            type: 'source',
            isConnectable: true,
            // id: `${getId()}-right`,
          },
        },
      };
      // Set the maxConnections property based on the node type
      switch (selectedNodeType.type) {
        case 'input':
          newNode.maxConnections = 2;
          break;
        case 'default':
          newNode.maxConnections = 1;
          break;
        case 'filter':
          newNode.maxConnections = 1;
          break;
        // Add cases for other node types and their respective maxConnections values
        default:
          newNode.maxConnections = Infinity; // Default to unlimited connections
          break;
      }

      if (newNode.alt === 'dataTable') {
        // newNode.data.selectedDatabase = initialDatabase;
        // newNode.data.buildOrderBy = initialColumn;
        newNode.data.selectedDatabase = initialDatabase;
        newNode.data.selectedTable = initialTable;
        newNode.data.selectedColumns = initialColumn;
        newNode.data.columnTypes = columnTypes;
      }
      else if (newNode.alt === 'createTable') {
        newNode.data.catalogList = dropdownCatalogs;
        newNode.data.schemasList = dropdownSchemas;
        newNode.data.tableList = dropdownTables;
      }
      else if (newNode.alt === 'sort') {

        newNode.data.buildOrderBy = [];
        // newNode.data.selectedColumns = '';
        newNode.data.isChecked = false;
        newNode.data.thenByIsChecked = false;
        newNode.data.selectedThenByColumns = [];
      } else if (newNode.alt === 'filter') {
        newNode.data.jsonFilterData = [];
        newNode.data.selectedGroupColumns = [];
        newNode.data.additionalCompareType = [];
        newNode.data.enterValue = '';
        newNode.data.additionalLogicalOperators = [];

      } else if (newNode.alt === 'join') {

        newNode.data.additionalColumnOneValues = [];
        newNode.data.additionalColumnTwoValues = [];
        newNode.data.additionalLogicalOperators = [];
        newNode.data.additionalCompareTypeValues = [];
      }
      // Update the selectedDatabase and selectedTable states in the parent component
      setSelectedDatabase(initialDatabase);
      setSelectedTable(initialTable);
      setSelectedColumn(initialColumn);
      setColumnTypes(columnTypes);

      setNodes((nodes) => nodes.concat(newNode));
      // Update the droppedNodes array with the new node
      // setDroppedNodes((prevDroppedNodes) => [...prevDroppedNodes, newNode.id]);
      setDroppedNodes((droppedNodes) => droppedNodes.concat(newNode.id));
      // Update the droppedNodes state by adding the new node
      // setDroppedNodes((droppedNodes) => [...droppedNodes, newNode]);
      console.log(JSON.stringify(nodes) + "NODESONDROP");
      console.log(JSON.stringify(edges) + "EDGESONDROP");
      console.log(JSON.stringify(droppedNodes) + "DROPPEDNODES");
      console.log(JSON.stringify(dropdownColumns) + "dropdownColumns");
      let popupContent;
      let selectedNodeData;

      // Get the first option value from the dropdown
      //  const firstOption = dropdownPopupDataTableValues[0];

      // Update the nodeData state with the default name

      if ((newNode.id).match(/^dataTable/)) {
        console.log("selectedDataTableNode::22")
        console.log("newNode::1", newNode)

        if ((newNode.id) in nodeData) {
          selectedNodeData = nodeData[newNode.id];
        }
        popupContent = <DataTablePopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
          onRemoveTable={handleRemoveTable}
          selectedNodeId={newNode.id}
          nodeName={newNode.id}
          onValueSubmit={handleDataTableSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges} // Pass the callback function as a prop
          edges={edges} // Pass the nodes array as a prop
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          connectionName={connectionNameValue}
          data={data}
          catalogList={dropdownCatalogs}
          schemasList={dropdownSchemas}
          tableList={dropdownTables}
          // columnList={dropdownColumns}
          columnList={dropdownColumns.map(column => column[0])}
          columnTypeList={dropdownColumns}
          connectionType={connectionTypeValue}
          isSelectedWindowFunction={isSelectedWindowFunction}
          windowFunctionList={windowFunctionsList}
        />

        setShowPopup(true);
        setPopupContent(popupContent);

      }
      else if ((newNode.id).match(/^sort/)) {


        if ((newNode.id) in nodeData) {
          selectedNodeData = nodeData[newNode.id];
        }
        console.log(JSON.stringify(selectedNodeData));


        popupContent = <SortPopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
          onRemoveTable={handleRemoveTable}
          selectedNodeId={newNode.id}
          nodeName={newNode.id}
          onValueSubmit={handleSortSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges}
          edges={edges}
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          data={data}
        />;

      } else if ((newNode.id).match(/^filter/)) {


        if ((newNode.id) in nodeData) {
          selectedNodeData = nodeData[newNode.id];
        }
        console.log(JSON.stringify(selectedNodeData));

        popupContent = <FilterPopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
          onRemoveTable={handleRemoveTable}
          selectedNodeId={newNode.id}
          nodeName={newNode.id}
          onValueSubmit={handleFilterSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges} // Pass the callback function as a prop
          edges={edges} 
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          data={data}
        />;

      } else if ((newNode.id).match(/^join/)) {


        if ((newNode.id) in nodeData) {
          selectedNodeData = nodeData[newNode.id];
        }
        console.log(JSON.stringify(selectedNodeData));


        popupContent = <JoinPopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
          onRemoveTable={handleRemoveTable}
          selectedNodeId={newNode.id}
          nodeName={newNode.id}
          onValueSubmit={handleJoinSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          data={data}
        />;

      }



      // Show the popup window and set the popup content 
      // setShowPopup(true);
      setPopupContent(popupContent);


    },

    [reactFlowInstance, nodes, droppedNodes]

  );

  // Function to close the popup window
  const closePopup = (value) => {
    setSubmittedValue(value);

    setShowPopup(false);
  };
  const handleRemoveTable = () => {
    // Close the popup

    closePopup();
  };

  const handlePopupSubmit = (selectedNodeId, name, dropdownValue) => {

    // Check if the selected node exists in the nodeData
    if (selectedNodeId in nodeData) {
      // Node already exists, no need to set the name and dropdownValue again
      return;
    }
    // Update the node data in the state with the submitted values
    setNodeData((prevNodeData) => ({
      ...prevNodeData,
      [selectedNodeId]: {
        name,
        dropdownValue,
      },
    }));
  };


  const getDataTableNodeIds = (joinNodeId) => {
    const dataTableNodeIds = [];
    edges.forEach(edge => {
      if (edge.source === 'dataTable') {
        dataTableNodeIds.push(edge.source);
      }
    });
    return dataTableNodeIds;
  }

  //  While double click the join node i can get the all
  //  sources of datatable nodes until the node which i selected.
  function getSourcesOfJoinNode(clickedJoinNodeId, edges) {
    const sourceNodes = [];

    function traverseEdges(currentNodeId) {
      edges.forEach((edge) => {
        if (edge.target === currentNodeId) {
          const sourceNodeId = edge.source;
          if (sourceNodeId.startsWith("dataTable")) {
            sourceNodes.push(sourceNodeId);
          } else if (sourceNodeId.startsWith("sqlEditor")) {
            sourceNodes.push(sourceNodeId);
          }
          else {
            traverseEdges(sourceNodeId);
          }
        }
      });
    }

    traverseEdges(clickedJoinNodeId);

    return sourceNodes;
  }

  //  While double click the join node i can get the all
  //  sources of datatable nodes until the node which i selected.
  function getSourcesAllNodes(clickedJoinNodeId, edges) {
    const sourceNodes = [];

    function traverseEdges(currentNodeId) {
      edges.forEach((edge) => {
        if (edge.target === currentNodeId) {
          const sourceNodeId = edge.source;
          //  if (sourceNodeId.startsWith("dataTable")) {
          sourceNodes.push(sourceNodeId);
          //  } else {
          traverseEdges(sourceNodeId);
          // }
        }
      });
    }

    traverseEdges(clickedJoinNodeId);

    return sourceNodes;
  }

  const handleNodeDoubleClick = async (event, node) => {
    console.log(JSON.stringify(node.data) + "NODEDATA");

    // Open the popup when a node is double-clicked
    const selectedNode = node;
    console.log(JSON.stringify(selectedNode.data.selectedTable) + "selectedNode");

    const selectedNodeId = selectedNode.id;
    setSelectedNodeId(selectedNodeId);
    // Extract the selected values from the node
    const selectedDatabase = node.data.selectedDatabase;
    const selectedTable = node.data.selectedTable;
    let selectedColumns = node.data.selectedColumns;
    console.log(JSON.stringify(selectedTable) + "*********888INIALNODEDOUBLECLICK");
    console.log(JSON.stringify(selectedDatabase) + "selectedDatabaseselectedDatabase");
    let selectedNodeData;
    let popupContent;
    let selectedRightListColumnsValue = '';
    if ((selectedNodeId).match(/^sqlEditor/)) {
      // SHOW button functionalities boolean value
      setFormDataTableSubmitted(true);
      setShowCharts(false);
      console.log(JSON.stringify(node.data) + "NODE>DATA");

      popupContent = <SqlEditorPopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={node.data.label}
        onValueSubmit={handleSqlEditorSubmit}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes}
        data={data}
        rightListValue={node.data.rightList}
        leftListValue={node.data.leftList}
        initialCatalog={node.data.catalog}
        initialTable={node.data.selectedTable}
        catalogList={node.data.catalogDataList || dropdownCatalogs}
        schemasList={node.data.schemaDataList || dropdownSchemas}
        tableList={node.data.tableDataList || dropdownTables}
        columnList={node.data.columnDataList || dropdownColumns.map(column => column[0])}
        initialCatalogList={dropdownCatalogs}
        initialSchemaList={dropdownSchemas}
        initialTableList={dropdownTables}
        initialColumnList={dropdownColumns}
        columnTypes={columnTypes}
        columnTypeList={node.data.columnTypeListValue || dropdownColumns}
        sqlTextValue={node.data.sql || ''}
        selectedFieldsFromEditorValue={node.data.selectedFieldsFromEditor || ''}
        editorCatalogValue={node.data.editorCatalog || ''}
        editorSchemaValue={node.data.editorSchema || ''}
        editorTableValue={node.data.editorTable || ''}

      />


    } else if ((selectedNodeId).match(/^createTable/)) {
      // SHOW button functionalities boolean value
      setFormDataTableSubmitted(true);
      setShowCharts(false);
      console.log(JSON.stringify(node.data) + "NODE>DATA");


      popupContent = <CreateTablePopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={node.data.label}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        setEdges={setEdges}
        edges={edges}
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes}
        data={data}
        onValueSubmit={connectionTypeValue !== 'SQLite' ? handleCreateTableSubmit : handleCreateTableSqliteSubmit}
        // onValueSubmit={handleCreateTableSubmit}
        loadCatalogList={dropdownCatalogs}
        loadDatabaseList={dropdownSchemas}
        setLoadDatabaseList={setDropdownSchemas}
        loadTableList={dropdownTables}
        setLoadTableList={setDropdownTables}
        schemaDropdownValue={node.data.schemaDropdown}
        catalogDropdownValue={node.data.catalogDropdown}
        node={node}
        schema={dropdownSchemas}
        setSchema={''}
        table={dropdownTables}
        setTable={''}
        chunk={''}
        setChunk={''}
        delimeter={''}
        setDelimeter={''}
        loadTableListNotSqliteOptionsValues={node.data.loadTableListNotSqliteOptions}
        loadTableListUpdatedValues={node.data.loadTableList}
        catalogDataList={dropdownCatalogs}
        schemaDataList={dropdownSchemas}
        tableDataList={dropdownTables}
        tableDropdownNotSqliteValue={node.data.tableDropdownNotSqlite}
        schemaSqliteDropdownValue={node.data.schemaSqliteDropdown}
        tableDropdownSqliteValue={node.data.tableDropdown}
        connectionType={connectionTypeValue}

      />

    }

    else if ((selectedNodeId).match(/^dataTable/)) {
      console.log("setDataTableNode::3", JSON.stringify(node.data.selectedAdditionalNestedWindowFunction))
      // SHOW button functionalities boolean value
      setFormDataTableSubmitted(true);
      setShowCharts(false);
      console.log(JSON.stringify(node.data.partitionBy) + "NODE>DATA::3");

      popupContent = <DataTablePopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={node.data.label}
        onValueSubmit={handleDataTableSubmit}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        setEdges={setEdges} // Pass the callback function as a prop
        edges={edges} // Pass the nodes array as a prop
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes}
        connectionName={connectionNameValue}
        data={data}
        rightListValue={node.data.rightList}
        leftListValue={node.data.leftList}
        selectedWindowFunctionValue={node.data.selectedWindowFunction} 
        selectedNestedWindowFunctionValue={node.data.selectedNestedWindowFunction}
        selectedTableColumnsValue={node.data.selectedTableColumns}
        orderByValue={node.data.orderBy}
        partitionByValue={node.data.partitionBy}
        showWindowFunctionValue={node.data.showWindowFunction}
        selectedAdditionalWindowFunctionValue={node.data.selectedAdditionalWindowFunction}
        selectedAdditionalNestedWindowFunctionValue={node.data.selectedAdditionalNestedWindowFunction}
        showAdditionalGroupInputsLength={node.data.showAdditionalGroupInputsLength}
        selectedAdditionalCountsValue={node.data.selectedAdditionalCounts}
        additionalSelectedTableColumnsValue={node.data.additionalSelectedTableColumns}
        additionalOrderByValue={node.data.additionalOrderBy}
        additionalPartitionByValue={node.data.additionalPartitionBy}
        selectedCountValue={node.data.selectedCount}
        ntileInputValue={node.data.ntileValue}
        ntileAdditionalInputValue={node.data.ntileAdditionalValue}
        initialCatalog={node.data.catalog}
        initialTable={node.data.selectedTable}
        catalogList={node.data.catalogDataList || dropdownCatalogs}
        schemasList={node.data.schemaDataList || dropdownSchemas}
        tableList={node.data.tableDataList || dropdownTables}
        columnList={node.data.columnDataList || dropdownColumns.map(column => column[0])}
        initialCatalogList={dropdownCatalogs}
        initialSchemaList={dropdownSchemas}
        initialTableList={dropdownTables}
        initialColumnList={dropdownColumns}
        columnTypes={columnTypes}
        columnTypeList={node.data.columnTypeListValue || dropdownColumns}
        connectionType={connectionTypeValue}
        isFilterTableValueSame={node.data.isFilterTableValueSame || true}
        isSelectedWindowFunction={node.data.isSelectedWindowFunction}
        windowFunctionList={node.data.windowFunctionsList}

      />

    } else if ((selectedNodeId).match(/^sort/)) {

      setFormDataTableSubmitted(false);

      console.log(JSON.stringify(node.data.selectedTable) + "node.data.selectedTable");
      console.log(JSON.stringify(selectedColumns) + "node.data.selectedColumnsINSIDESORT");
      const isChecked = node.data.isChecked;
      console.log(JSON.stringify(isChecked) + "isChecked");

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });



      if (connectedToSource) {
        // Sort node is connected to a DataTable node
        // Perform your desired actions here
        console.log('Sort node is connected to a DataTable node');

        const currentDataTableNode = nodes.find((node) => node.alt === 'dataTable');
        if (currentDataTableNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);

          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          console.log(JSON.stringify(JSON.stringify(nodeData) + "nodeData-----"));
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          // const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
          let columns = '';
          let catalogValue = '';
          let selectedDatabaseValue = '';
          let selectedCurrentTableValue = '';
          let aliasColumnNamesValue = '';

          if (selectedDataTableNodeData && selectedDataTableNodeData.length > 0) {

            catalogValue = selectedDataTableNodeData.map(node => node.catalog);
            selectedDatabaseValue = selectedDataTableNodeData.map(node => node.selectedDatabase);
            selectedCurrentTableValue = selectedDataTableNodeData.map(node => node.selectedTable);
            columns = selectedDataTableNodeData.map(node => node.columnsWithCatalogs).filter(item => item !== '');
            aliasColumnNamesValue = (selectedDataTableNodeData.map(node => node.aliasColumnNames) || '').filter(item => item !== '');

          } else {

            catalogValue = selectedDataTableNodeData[0]?.catalog;
            selectedDatabaseValue = selectedDataTableNodeData[0]?.selectedDatabase
            selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable
            columns = selectedDataTableNodeData[0]?.columnsWithCatalogs;
            aliasColumnNamesValue = (selectedDataTableNodeData[0]?.aliasColumnNames).filter(item => item !== '');
          }



          console.log(JSON.stringify(node.data.selectedThenByColumns) + "node.data.selectedThenByColumns");
          console.log(JSON.stringify(node.data.showAdditionalinputlength) + "length");
          // Handle the popup window for sort nodes
          popupContent = <SortPopupComponent onClose={closePopup} // Pass droppedNodes when calling onClose
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleSortSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            edges={edges}
            setEdges={setEdges}
            selectedPreviousTable={node.data.selectedTable}
            //  selectedDatabase = {currentDataTableNode.data.selectedDatabase}
            // selectedCurrentTableValue={currentDataTableNode.data.selectedTable}
            catalog={catalogValue}
            selectedDatabase={selectedDatabaseValue}
            selectedCurrentTableValue={selectedCurrentTableValue}
            columns={columns}
            firstColumn={node.data.selectedColumns}
            isCheckedValue={node.data.isChecked}
            thenByIsCheckedValue={node.data.thenByIsChecked}
            selectedThenByColumnValue={node.data.selectedThenByColumns}
            showAdditionalinputlength={node.data.showAdditionalinputlength}
            aliasColumn={aliasColumnNamesValue}
            connectionType={connectionTypeValue}
          />;
        } else {
          popupContent = (
            <SortPopupComponent
              onClose={closePopup}
              onRemoveTable={handleRemoveTable}
              selectedNodeId={selectedNodeId}
              nodeName={node.data.label}
              onValueSubmit={handleSortSubmit}
              setNodes={setNodes}
              nodes={nodes}
              droppedNodes={droppedNodes}
              setDroppedNodes={setDroppedNodes}
              edges={edges}
              setEdges={setEdges}
              columns={[]} // Empty columns array
              firstColumn={''}
              isCheckedValue={false}
              thenByIsCheckedValue={false}
              selectedThenByColumnValue={[]}
              showAdditionalinputlength={0}
              aliasColumn={''}
              //  isCheckedValue={false}
              connectionType={''}
            />
          );
        }

      } else {
        // Sort node is not connected to a DataTable node
        console.log('Sort node is not connected to a DataTable node');

        // Handle the popup window for sort nodes with empty columns
        popupContent = (
          <SortPopupComponent
            onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleSortSubmit}
            setNodes={setNodes}
            nodes={nodes}
            droppedNodes={droppedNodes}
            setDroppedNodes={setDroppedNodes}
            edges={edges}
            setEdges={setEdges}
            columns={[]} // Empty columns array
            firstColumn={''}
            isCheckedValue={false}
            thenByIsCheckedValue={false}
            selectedThenByColumnValue={[]}
            showAdditionalinputlength={0}
            aliasColumn={''}
            //  isCheckedValue={false}
            connectionType={''}
          />
        );
      }

    } else if ((selectedNodeId).match(/^filter/)) {
      console.log(JSON.stringify(node.data.selectedTable) + "node.data.selectedTable");
      console.log(JSON.stringify(selectedNodeId) + "selectedNodeId");
      console.log("isFilterTableValueSame::4",filterTableValueSame)
      let firstColumn;
      if (!filterTableValueSame){
        firstColumn = "" 
      } else {
        firstColumn = node.data.selectedFilterColumns
      }
      console.log("isFilterTableValueSame::5",firstColumn)
      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });


      if (connectedToSource) {
        console.log('Edge type:', edgeTypeButton);

        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        const sortNode = nodes.find((node) => node.alt === 'sort');
        // const dataTableNode = nodes.find((node) => node.alt === 'dataTable');

        if (dataTableNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData-1");

          let selectedCurrentTableValue = '';
          let columns = '';
          let columnType = '';
          let aliasColumnNamesValue;
          let windowFunctionWithConditionValue = '';
          let columnTypeListValue = '';
          let catalogValue = '';
          let selectedDatabaseValue = '';
          console.log("filter::1", selectedDataTableNodeData);
          if (selectedDataTableNodeData && selectedDataTableNodeData.length > 0) {

            catalogValue = selectedDataTableNodeData.map(node => node.catalog);
            selectedDatabaseValue = selectedDataTableNodeData.map(node => node.selectedDatabase);

            selectedCurrentTableValue = selectedDataTableNodeData.map(node => node.selectedTable);
            columns = selectedDataTableNodeData.map(node => node.columnsWithCatalogs).filter(item => item !== '');
            //columns = selectedDataTableNodeData.map(node => node.formattedLeftList).filter(item => item !== '');
            columnType = selectedDataTableNodeData.map(node => node.columnTypeListValue);
            aliasColumnNamesValue = (selectedDataTableNodeData.map(node => node.aliasColumnNames)).filter(item => item !== '');
            windowFunctionWithConditionValue = (selectedDataTableNodeData.map(node => node.windowFunctionWithCondition) || '').filter(item => item !== '');
            columnTypeListValue = selectedDataTableNodeData.map(node => node.columnTypeListValue);
          } else {

            catalogValue = selectedDataTableNodeData[0]?.catalog;
            selectedDatabaseValue = selectedDataTableNodeData[0]?.selectedDatabase;

            selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
            columns = selectedDataTableNodeData[0]?.columnsWithCatalogs;
            columnType = selectedDataTableNodeData[0]?.columnTypeListValue;
            aliasColumnNamesValue = (selectedDataTableNodeData[0]?.aliasColumnNames).filter(item => item !== '');
            windowFunctionWithConditionValue = (selectedDataTableNodeData[0]?.windowFunctionWithCondition).filter(item => item !== '');
            columnTypeListValue = selectedDataTableNodeData[0]?.columnTypeListValue;
          }
          const edgeConnectionId = edges.find(edge => edge.source === selectedNodeId || edge.target === selectedNodeId)?.id;
          edges.find(edge => {
            console.log('Edge:', edge);
            console.log('Is edge.source matching selectedNodeId:', edge.source === selectedNodeId);
            console.log('Is edge.source matching selectedNodeId:', edge.target === selectedNodeId);

          });


          let edgeValue = edgeButtonValues[edgeConnectionId];

          if (edgeValue) {
            // Perform the comparison or further processing based on the edge value
            console.log('Edge Connection ID:', edgeConnectionId);
            console.log('Edge Button Value:', edgeValue);
          } else {
            edgeValue = '';
          }
          const selectedTable = dataTableNode.data.selectedTable;
          const selectedDatabase = dataTableNode.data.selectedDatabase;
          console.log(JSON.stringify(selectedDatabase) + "selectedDatabaseFILTER");
          const filterColumns = selectedTable.columns;
          console.log(JSON.stringify(node.data.additionalLogicalOperators) + "node.data.FILTERadditionalLogicalOperators");

          popupContent = <FilterPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleFilterSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            setEdges={setEdges} // Pass the callback function as a prop
            edges={edges} 
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            catalog={catalogValue}
            selectedDatabase={selectedDatabaseValue}
            selectedCurrentTable={selectedCurrentTableValue}
            firstCompareToValue={node.data.compareType}
            connectionValue={true}
            selectedGroupColumnValue={node.data.selectedGroupColumns}
            showAdditionalinputGrouplength={node.data.showAdditionalinputGrouplength}
            selectedPreviousTable={node.data.selectedTable}
            columns={columns}
            columnTypeList={columnTypeListValue}
            additionalCompareTypeValues={node.data.additionalCompareType}
            firstEnterValue={node.data.enterValue || ''}
            secondEnteredValue={node.data.enterSecondValue || ''}
            //firstColumn={node.data.selectedFilterColumns || ''}
            firstColumn={firstColumn}
            filterColumn={node.data.filterColumn}
            //firstColumn={node.data.firstColumn}
            groupEnterValue={node.data.additionalTextboxValues}
            additionalLogicalOperatorsValue={node.data.additionalLogicalOperators}
            buttonValue={edgeValue}
            aliasColumn={aliasColumnNamesValue}
            windowFunctionWithCondition={windowFunctionWithConditionValue}
            connectionType={connectionTypeValue}
          />;

          // Continue with your logic using the selectedTable and filterColumns
        } else {

          // Handle the case when the DataTable node is not found
          // Handle the popup window for filter nodes
          popupContent = <FilterPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleFilterSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            setEdges={setEdges} // Pass the callback function as a prop
            edges={edges} 
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            connectionValue={false}
            catalog={''}
            selectedDatabase={''}
            selectedCurrentTable={''}
            firstCompareToValue={[]}
            selectedGroupColumnValue={''}
            showAdditionalinputGrouplength={0}
            selectedPreviousTable={''}
            columns={[]}
            additionalCompareTypeValues={[]}
            firstEnterValue={''}
            firstColumn={[]}
            groupEnterValue={[]}
            additionalLogicalOperatorsValue={[]}
            aliasColumn={''}
            connectionType={''}
          />;
        }

      } else {
        popupContent = <FilterPopupComponent onClose={closePopup}
          onRemoveTable={handleRemoveTable}
          selectedNodeId={selectedNodeId}
          nodeName={node.data.label}
          onValueSubmit={handleFilterSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges} // Pass the callback function as a prop
          edges={edges} 
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          connectionValue={false}
          catalog={''}
          selectedDatabase={''}
          selectedCurrentTable={''}
          firstCompareToValue={[]}
          selectedGroupColumnValue={''}
          showAdditionalinputGrouplength={0}
          selectedPreviousTable={''}
          columns={[]}
          additionalCompareTypeValues={[]}
          firstEnterValue={''}
          firstColumn={[]}
          groupEnterValue={[]}
          additionalLogicalOperatorsValue={[]}
          aliasColumn={''}
          connectionType={''}
        />;
      }
    } else if ((selectedNodeId).match(/^join/)) {
      console.log(JSON.stringify(nodes) + "nodes");
      console.log(JSON.stringify(edges) + "edges");
      console.log(JSON.stringify(node.data.selectedTable) + "SELECTEDTABLE");
      console.log(JSON.stringify(node.data) + "node.data");

      const dataTableNodeIds = getDataTableNodeIds(selectedNodeId);

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });



      if (connectedToSource) {

        // Execute your logic here if the selected node is connected to a source node
        console.log('Selected node is connected to a source node');

        console.log('Edge type:', edgeTypeButton);
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');

        if (dataTableNode) {
          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE NODES :" + sourceDataTableNodes);

          // Important conditions 
          // for matching nodes in all the edges whcih is sourcenode is datatable
          const targetNodes = edges.map((edge) => edge.target); // Get all target nodes
          // alert(JSON.stringify(targetNodes) + "targetNodes");
          // Filter target nodes that have two source connections starting with "dataTable"
          const matchingTargets = targetNodes.filter((target, index) => {
            const sourceConnections = edges.filter((edge) => edge.target === target && edge.source.startsWith("dataTable"));
            return sourceConnections.length === 2 && targetNodes.indexOf(target) === index;  // target if it duplicate then this indexof will remove the duplicates
          });

          //  alert(JSON.stringify(matchingTargets) + "---------matchingTargets");
          console.log("Target nodes with 2 source connections starting with 'dataTable':", matchingTargets);
          const matchingSourceIds = matchingTargets.flatMap((target) =>
            edges.filter((edge) => edge.target === target && edge.source.startsWith("dataTable")).map((edge) => edge.source)
          );

          // Check if the join node has exactly two connections
          const joinNodeConnections = edges.filter((edge) => edge.source === selectedNodeId || edge.target === selectedNodeId);
          const hasTwoConnections = joinNodeConnections.length >= 2;
          console.log(JSON.stringify(joinNodeConnections) + "joinNodeConnections");

          const sources = joinNodeConnections.map(connection => connection.source);
          console.log(JSON.stringify(sources) + "sources***********");

          const selectedTwoDataTable = sourceDataTableNodes;


          const selectedDataTableNodeData = selectedTwoDataTable.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          let selectedTablesUntilJoinNode;
          let selectedDatabaseUntilJoinNode;
          let selectedCatalogUntilJoinNode;

          selectedCatalogUntilJoinNode = selectedDataTableNodeData.map(node => node.catalog);

          selectedDatabaseUntilJoinNode = selectedDataTableNodeData.map(node => node.selectedDatabase);

          selectedTablesUntilJoinNode = selectedDataTableNodeData.map(node => node.selectedTable);


          console.log("selectedDataTableNodeData::1",selectedDataTableNodeData);
          let selectedColumnsUntilJoinNode;
          selectedColumnsUntilJoinNode = selectedDataTableNodeData.map(node => node.columnsWithCatalogs);
          console.log(JSON.stringify(selectedColumnsUntilJoinNode) + "selectedColumnsUntilJoinNode::1");

          let windowFunctionWithCondition;
          windowFunctionWithCondition = selectedDataTableNodeData.map(node => node.windowFunctionWithCondition);

          if (hasTwoConnections) {

            // Access the DataTable node data if needed
            const dataTableNode = edges.find(
              (edge) => {
                const isTargetMatch = edge.target === node.id;
                const sourceNode = nodes.find((n) => n.id === edge.source);
                const isDataTableSource = sourceNode && sourceNode.alt === 'dataTable';
                console.log('edge.target:', edge.target);
                console.log('nodes[]:', nodes);
                console.log('edges[]:', edges);
                console.log('isDataTableSource:', JSON.stringify(isDataTableSource));
                return isTargetMatch && isDataTableSource;

              });

            // Handle the popup window for filter nodes[]
            console.log("JOINPOPUP::1", JSON.stringify(node.data), node.data.datatableListOne, node.data.datatableListTwo, node.data.datatableOne,node.data.datatableTwo)
            popupContent = <JoinPopupComponent
              onClose={closePopup}
              onRemoveTable={handleRemoveTable}
              selectedNodeId={selectedNodeId}
              nodeName={node.data.label}
              onValueSubmit={handleJoinSubmit}
              setNodes={setNodes} // Pass the callback function as a prop
              nodes={nodes} // Pass the nodes array as a prop
              setEdges={setEdges} // Pass the callback function as a prop
              edges={edges} 
              droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
              setDroppedNodes={setDroppedNodes}
              firstJoinTypeValues={node.data.joinType}
              selectedCatalogUntilJoinNode={selectedCatalogUntilJoinNode}
              selectedDatabaseUntilJoinNode={selectedDatabaseUntilJoinNode}
              selectedTablesUntilJoinNode={selectedTablesUntilJoinNode}  // removed last datatablevalue in the updatedTablesUntilJoinNode
              selectedColumnsUntilJoinNode={selectedColumnsUntilJoinNode}
              datatableOne={node.data.datatableListOne}    // firsttablevalue
              datatableTwo={node.data.datatableListTwo}    // secondtablevalue
              datatableOneFirstValue={node.data.datatableOne}
              datatableTwoFirstValue={node.data.datatableTwo}
              firstCompareToValues={node.data.compareType}
              additionalLogicalOperatorsValue={node.data.additionalLogicalOperators}
              additionalColumnOneValues={node.data.additionalColumnOneValues}
              additionalColumnTwoValues={node.data.additionalColumnTwoValues}
              showAdditionalColumnslength={node.data.showAdditionalColumnslength || 0}
              additionalCompareTypeValues={node.data.additionalCompareTypeValues}
              windowFunctionWithCondition={windowFunctionWithCondition || ''}
              aliasColumn={selectedDataTableNodeData.map(node => node.aliasColumnNames) || ''}
              connectionType={connectionTypeValue}
            />;

          } else {

          }


        } else {
          // Handle the popup window for filter nodes
          popupContent = <JoinPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleJoinSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            setEdges={setEdges} // Pass the callback function as a prop
            edges={edges} 
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            firstJoinTypeValues={[]}
            selectedCatalogUntilJoinNode={[]}
            selectedDatabaseUntilJoinNode={[]}
            selectedTablesUntilJoinNode={[]}
            selectedColumnsUntilJoinNode={[]}
            dataTableOneNodeData={''}
            dataTableTwoNodeData={''}
            datatableOne={[]}    // firsttablevalue
            datatableTwo={[]}
            datatableOneFirstValue={''}
            datatableTwoFirstValue={''}
            additionalLogicalOperatorsValue={[]}
            additionalColumnOneValues={[]}
            additionalColumnTwoValues={[]}
            showAdditionalColumnslength={0}
            firstCompareToValues={[]}
            additionalCompareTypeValues={[]}
            connectionType={''}

          />;
        }

      } else {

        console.log('Selected node is not connected to a source node');

        // Handle the popup window for filter nodes
        popupContent = <JoinPopupComponent onClose={closePopup}
          onRemoveTable={handleRemoveTable}
          selectedNodeId={selectedNodeId}
          nodeName={node.data.label}
          onValueSubmit={handleJoinSubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges} // Pass the callback function as a prop
          edges={edges} 
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          firstJoinTypeValues={[]}
          selectedCatalogUntilJoinNode={[]}
          selectedDatabaseUntilJoinNode={[]}
          selectedTablesUntilJoinNode={[]}
          selectedColumnsUntilJoinNode={[]}
          dataTableOneNodeData={''}
          dataTableTwoNodeData={''}
          datatableOneFirstValue={''}
          datatableTwoFirstValue={''}
          additionalLogicalOperatorsValue={[]}
          additionalColumnOneValues={[]}
          additionalColumnTwoValues={[]}
          showAdditionalColumnslength={''}
          firstCompareToValues={[]}
          additionalCompareTypeValues={[]}
          connectionType={''}
        />;
      }



    } else if ((selectedNodeId).match(/^summarize/)) {
      // Handle the popup window for filter nodes
      popupContent = <JoinPopupComponent onClose={closePopup}
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={selectedNodeData?.name || ''}
        // nodeName={nodeName}
        // selectedOption={selectedOption}
        selectedOption={selectedNodeData?.option || ''}
        onValueSubmit={handlePopupSubmit}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        setEdges={setEdges} // Pass the callback function as a prop
        edges={edges} 
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes} />;
    } else if ((selectedNodeId).match(/^groupBy/)) {
      let selectedcolumns = [];
      let windowColumns = [];
      let selectedCatalogs = [];
      let selectedDatabases = [];
      let selectedTables = [];
      let aliasColumnValue = [];
      let aliasFunctionNamesValue = [];
      let windowFunctionWithConditionValue = '';

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {

        // Execute your logic here if the selected node is connected to a source node
        console.log('Selected node is connected to a source node');

        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');

        if (dataTableNode) {
          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);
          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
          const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;

          if (selectedDataTableNodeData && selectedDataTableNodeData.length > 1) {
            aliasColumnValue = (selectedDataTableNodeData.map(node => node.aliasColumnNames) || []).filter(item => item !== '');
            aliasFunctionNamesValue = selectedDataTableNodeData.map(node => node.aliasFunctionNames) || '';
            windowFunctionWithConditionValue = (selectedDataTableNodeData.map(node => node.windowFunctionWithCondition) || '').filter(item => item !== '');
            selectedCatalogs = selectedDataTableNodeData.map(node => node.catalog);
            selectedDatabases = selectedDataTableNodeData.map(node => node.selectedDatabase);
            selectedTables = selectedDataTableNodeData.map(node => node.selectedTable);
            selectedcolumns = selectedDataTableNodeData.map(node => node.rightList).filter(item => item !== '');
            console.log("selectedcolumns::11", selectedcolumns, windowFunctionWithConditionValue)
            //selectedcolumns = selectedDataTableNodeData.map(node => [...node.rightList,...node.windowFunctionList]).filter(item => item !== '');
            //selectedColumns = [...selectedcolumns,...windowFunctionList];
          } else {
            selectedcolumns = selectedDataTableNodeData[0]?.rightList;
            windowColumns = selectedDataTableNodeData[0]?.windowFunctionsList;
            selectedcolumns = [...selectedcolumns, windowColumns]
            //selectedColumns = [...selectedDataTableNodeData[0]?.rightList,selectedDataTableNodeData[0]?.windowFunctionList];
            console.log("selectedcolumns::112", selectedColumns)
            selectedCatalogs = selectedDataTableNodeData[0]?.catalog;
            selectedDatabases = selectedDataTableNodeData[0]?.selectedDatabase;
            selectedTables = selectedDataTableNodeData[0]?.selectedTable;
            aliasColumnValue = selectedDataTableNodeData[0]?.aliasColumnNames;
            aliasFunctionNamesValue = selectedDataTableNodeData[0]?.aliasFunctionNames || '';
            windowFunctionWithConditionValue = selectedDataTableNodeData[0]?.windowFunctionWithCondition || '';

          }

          console.log(JSON.stringify(selectedcolumns) + "selectedcolumns" +
            JSON.stringify(selectedCatalogs) + "selectedCatalogs" +
            JSON.stringify(selectedDatabases) + "selectedDatabases" +
            JSON.stringify(selectedTables) + "selectedTables");

          let selectedRightListColumnsValue = '';
          if (node.data.selectedRightlistColumns) {
            const selectedRightlistColumns = node.data.selectedRightlistColumns
            //  selectedRightListColumnsValue = selectedRightlistColumns.map(column => column.split('.').pop());
            selectedRightListColumnsValue = selectedRightlistColumns;
          }

          const selectedTable = dataTableNode.data.selectedTable;

          // Handle the popup window for filter nodes
          popupContent = <GroupByPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleGroupBySubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            setEdges={setEdges}
            nodes={nodes} // Pass the nodes array as a prop
            edges={edges}
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            // selectedCurrentTable={dataTableNode.data.selectedTable}
            selectedCurrentDatabase={selectedDataTableNodeData[0]?.selectedDatabase}
            selectedCurrentTable={selectedDataTableNodeData[0]?.selectedTable}
            // columnsData={columns}
            columnsData={selectedcolumns}
            catalogsData={selectedCatalogs}
            databasesData={selectedDatabases}
            tablesData={selectedTables}
            selectedRightListValue={selectedRightListColumnsValue}
            selectedLeftListValue={node.data.selectedLeftListColumns}
            data={data}
            selectedCurrentTableDN={dataTableNode.data.selectedTable}
            selectedPreviousTable={node.data.selectedCurrentTable}
            aliasColumn={aliasColumnValue}
            aliasFunctionNames={aliasFunctionNamesValue}
            windowFunctionWithCondition={windowFunctionWithConditionValue}
            connectionType={connectionTypeValue}
          />;

        } else {

          console.log('Selected node is not connected to a source node');
          // Handle the popup window for filter nodes
          popupContent = <GroupByPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleGroupBySubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            setEdges={setEdges}
            edges={edges}
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentTable={''}
            selectedPreviousTable={''}
            aliasColumn={''}
            aliasFunctionNames={''}
            connectionType={''}
          />;
        }
      } else {
        // Handle the popup window for filter nodes
        popupContent = <GroupByPopupComponent onClose={closePopup}
          onRemoveTable={handleRemoveTable}
          selectedNodeId={selectedNodeId}
          nodeName={node.data.label}
          onValueSubmit={handleGroupBySubmit}
          setNodes={setNodes} // Pass the callback function as a prop
          nodes={nodes} // Pass the nodes array as a prop
          setEdges={setEdges}
          edges={edges}
          droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
          setDroppedNodes={setDroppedNodes}
          selectedCurrentTable={''}
          aliasColumn={''}
          aliasFunctionNames={''}
          connectionType={''}
        />;
      }
    } else if ((selectedNodeId).match(/^append/)) {
      // Handle the popup window for filter nodes
      popupContent = <AppendPopupComponent onClose={closePopup}
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={selectedNodeData?.name || ''}
        // nodeName={nodeName}
        // selectedOption={selectedOption}
        selectedOption={selectedNodeData?.option || ''}
        onValueSubmit={handlePopupSubmit}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes}
        connectionType={connectionTypeValue}
      />;
    } else if ((selectedNodeId).match(/^extract/)) {
      // Handle the popup window for filter nodes
      popupContent = <ExtractPopupComponent onClose={closePopup}
        onRemoveTable={handleRemoveTable}
        selectedNodeId={selectedNodeId}
        nodeName={selectedNodeData?.name || ''}
        // nodeName={nodeName}
        // selectedOption={selectedOption}
        selectedOption={selectedNodeData?.option || ''}
        onValueSubmit={handlePopupSubmit}
        setNodes={setNodes} // Pass the callback function as a prop
        nodes={nodes} // Pass the nodes array as a prop
        droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
        setDroppedNodes={setDroppedNodes} />;
    } else if ((selectedNodeId).match(/^line/)) {
      let selectedDataBaseCombined;
      let selectedTableCombined;
      let selectedCurrentTableValue = '';
      let selectedSqlEditorNodeData = '';

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        const sqlEditorNode = nodes.find((node) => node.alt === 'sqlEditor');

        if (dataTableNode || sqlEditorNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          const sourceSqlEditorNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log(JSON.stringify(sourceDataTableNodes) + "sourceDataTableNodes" +
            JSON.stringify(sourceSqlEditorNodes) + "sourceSqlEditorNodes");

          if (sourceDataTableNodes.some((node) => node.includes("dataTable"))) {
            console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
            const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
            const columns = selectedDataTableNodeData[0]?.columns;
            const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
              return {
                name: data.name,
                catalog: data.catalog,
                dataBaseName: data.selectedDatabase,
                tableName: data.selectedTable,
                // selectedTableColumns: data.columns,
                selectedTableColumns: data.rightList,
                aliasColumns: data.aliasColumnNames
              };
            });

            console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValuesInQB::11");
            const selectedCatalogCombined = selectedTableColumnsValues.map((data) => data.catalog);
            selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
            selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
            const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);
            const aliasColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.aliasColumns);
            let selectedTableColumnsValuesCombinedTwotables = '';
            let idsOnly = '';

            if (selectedTableColumnsValuesCombined) {

              selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined, ...aliasColumnsValuesCombined);

              selectedRightListColumnsValue = selectedTableColumnsValuesCombinedTwotables.map(column => column.split('.').pop());


              idsOnly = selectedTableColumnsValuesCombinedTwotables.filter(column => column.endsWith("_id"));
            }


            console.log(JSON.stringify(idsOnly) + "idsss");
            console.log(selectedTableColumnsValuesCombined);
            console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
            console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
            console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");
          } else if (sourceSqlEditorNodes.some((node) => node.includes("sqlEditor"))) {
            selectedSqlEditorNodeData = sourceSqlEditorNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedSqlEditorNodeData) + "selectedSqlEditorNodeData");

          }

          // Handle the popup window for filter nodes
          popupContent = <LineChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleLineSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined || ''}
            selectedCurrentTablesCombined={selectedTableCombined || ''}
            selectedColumnsCombined={selectedRightListColumnsValue || selectedSqlEditorNodeData[0].selectedFieldsFromEditor}

            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            leftListValue={node.data.leftList}
            rightListValue={node.data.rightList}
            verticalLabelValue={node.data.verticalLabel}
            horizantalLabelValue={node.data.horizantalLabel}

            selectedCurrentTable={selectedCurrentTableValue || selectedSqlEditorNodeData[0]?.editorTable}
            selectedPreviousTable={node.data.selectedCurrentTable}

          />;
        } else {

          popupContent = linePopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

        }
      } else {
        popupContent = linePopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

      }



    } else if ((selectedNodeId).match(/^bar/)) {
      let selectedDataBaseCombined;
      let selectedTableCombined;
      let selectedDataTableNodeData;
      let selectedSqlEditorNodeData;
      let selectedCurrentTableValue = '';

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        const sqlEditorNode = nodes.find((node) => node.alt === 'sqlEditor');
        if (dataTableNode || sqlEditorNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);

          const sourceSqlEditorNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log(JSON.stringify(sourceDataTableNodes) + "sourceDataTableNodes" +
            JSON.stringify(sourceSqlEditorNodes) + "sourceSqlEditorNodes");

          if (sourceDataTableNodes.some((node) => node.includes("dataTable"))) {
            console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

            selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
            selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
            const columns = selectedCurrentTableValue.columns;
            const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
              return {
                name: data.name,
                catalog: data.catalog,
                dataBaseName: data.selectedDatabase,
                tableName: data.selectedTable,
                // selectedTableColumns: data.columns,
                selectedTableColumns: data.rightList,
                aliasColumns: data.aliasColumnNames
              };
            });

            console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValues");

            selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
            selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
            const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);

            const aliasColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.aliasColumns);

            let selectedTableColumnsValuesCombinedTwotables = '';
            let idsOnly = '';
            if (selectedTableColumnsValuesCombined) {

              selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined, ...aliasColumnsValuesCombined);

              selectedRightListColumnsValue = selectedTableColumnsValuesCombinedTwotables.map(column => column.split('.').pop());


              idsOnly = selectedTableColumnsValuesCombinedTwotables.filter(column => column.endsWith("_id"));
            }


            console.log(JSON.stringify(idsOnly) + "idsss");
            console.log(selectedTableColumnsValuesCombined);
            console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
            console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
            console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");

          }

          else if (sourceSqlEditorNodes.some((node) => node.includes("sqlEditor"))) {
            selectedSqlEditorNodeData = sourceSqlEditorNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedSqlEditorNodeData) + "selectedSqlEditorNodeData");

          }

          // Handle the popup window for filter nodes
          popupContent = <BarChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleBarSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined || ''}
            selectedCurrentTablesCombined={selectedTableCombined || ''}
            selectedColumnsCombined={selectedRightListColumnsValue || selectedSqlEditorNodeData[0].selectedFieldsFromEditor}
            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            leftListValue={node.data.leftList}
            rightListValue={node.data.rightList}
            verticalLabelValue={node.data.verticalLabel}
            horizantalLabelValue={node.data.horizantalLabel}
            selectedCurrentTable={selectedCurrentTableValue || selectedSqlEditorNodeData[0]?.editorTable}
            selectedPreviousTable={node.data.selectedCurrentTable}
          />;

        } else {
          popupContent = barPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handlePieSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);
        }
      } else {
        popupContent = barPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handlePieSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

      }

    } else if ((selectedNodeId).match(/^pie/)) {

      let selectedDataBaseCombined;
      let selectedTableCombined;
      let rightListColumnsValue = '';
      let selectedTableColumnsValuesCombinedTwotables = '';
      let idsOnly = '';
      let selectedSqlEditorNodeData = '';

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {

        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        const sqlEditorNode = nodes.find((node) => node.alt === 'sqlEditor');
        if (dataTableNode || sqlEditorNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const sourceSqlEditorNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);
          if (sourceDataTableNodes.some((node) => node.includes("dataTable"))) {

            const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
            console.log(JSON.stringify(JSON.stringify(nodeData) + "nodeData-----pie"));
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");

            const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
            const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
            const columns = selectedDataTableNodeData[0]?.columns;
            const columnTypeListValues = selectedDataTableNodeData[0]?.columnTypeListValue;
            const windowFunctionsAliascolumns = selectedDataTableNodeData[0].windowFunctionWithCondition;
            const aliasColumnsAndTypes = selectedDataTableNodeData[0].aliasColumnsAndTypes;
            const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
              return {
                name: data.name,
                catalog: data.catalog,
                dataBaseName: data.selectedDatabase,
                tableName: data.selectedTable,
                selectedTableColumns: data.columns,
                rightList: data.rightList,
                aliasColumns: data.aliasColumnNames,
                aliasColumnsAndTypes: data.aliasColumnsAndTypes

              };
            });

            console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValues");

            selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
            selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
            // const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);

            const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.rightList);

            const aliasColumnValuesCombined = selectedTableColumnsValues.map((data) => data.aliasColumns);

            console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");


            if (selectedTableColumnsValuesCombined) {

              selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined, ...aliasColumnValuesCombined);

              console.log(JSON.stringify(selectedTableColumnsValuesCombinedTwotables) + "selectedTableColumnsValuesCombinedTwotables");
              rightListColumnsValue = selectedTableColumnsValuesCombinedTwotables.map(column => column.split('.').pop());

              console.log(JSON.stringify(rightListColumnsValue) + "rightListColumnsValue");
              //alert(JSON.stringify(selectedTableColumnsValuesCombinedTwotables)+"selectedTableColumnsValuesCombinedTwotables");
              setTwoTableColumnsCombined(rightListColumnsValue);
              // List of numeric data types
              const numericDataTypes = ["integer", "bigint", "TINYINT", "SMALLINT", "numeric", "decimal", "bigint", "real", "double", "smallint",];
              // Use the filter method to get columns with numeric data types
              //const numericColumns = columnTypeListValues.filter(column => numericDataTypes.includes(column[1]));
              // Use a regular expression to filter columns with numeric data types
              const numericColumns = columnTypeListValues.filter(column => {
                const dataType = column[1].toLowerCase(); // Convert to lowercase for case-insensitive comparison
                return numericDataTypes.includes(dataType) || /^\d+$/.test(dataType);
              });


              // Use a regular expression to filter columns with numeric data types
              // const numericColumns = columnTypeListValues.filter(column => {
              //   const dataType = column[1].toLowerCase();
              //   return /^(int|smallint|bigint|\d+)$/.test(dataType);
              // });
              console.log(JSON.stringify(numericColumns) + "numericColumns");

              // idsOnly = rightListColumnsValue.filter(column => column.endsWith("id"));
              idsOnly = numericColumns.map(column => column[0]);



              // Define a function to get the column type based on the column name
              function getColumnType(columnName) {
                const columnInfo = columnTypeListValues.find(item => item[0] === columnName);
                return columnInfo ? columnInfo[1] : '';
              }

              // Process each element in windowFunctionWithCondition
              // const result = windowFunctionsAliascolumns.map(item => {
              //   const matches = item.match(/\(([^)]+)/); // Match text within parentheses
              //   if (matches) {
              //     const textWithinParentheses = matches[1].trim();
              //     const columnNames = textWithinParentheses.split(/[,*\/-]/).map(column => column.trim());

              //     const columnTypes = columnNames.map(columnName => getColumnType(columnName));
              //     const aliasColumnName = item.split(' AS ')[1];
              //     return {
              //       columnNames,
              //       aliasColumnName,
              //       columnTypes
              //     };
              //   }
              //   return null;

              // });

              // console.log(JSON.stringify(result) + "result");
              console.log(JSON.stringify(idsOnly) + "idsss");
              console.log(selectedTableColumnsValuesCombined);
              console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
              console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
              console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");

            }
          } else if (sourceSqlEditorNodes.some((node) => node.includes("sqlEditor"))) {

            selectedSqlEditorNodeData = sourceSqlEditorNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedSqlEditorNodeData) + "selectedSqlEditorNodeData");

          }


          //  setFormDataTableSubmitted(false);
          // Handle the popup window for filter nodes
          popupContent = <PieChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            selectedOption={selectedNodeData?.option || ''}
            onValueSubmit={handlePieSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined}
            selectedCurrentTablesCombined={selectedTableCombined}
            //  selectedColumnsCombined={selectedTableColumnsValuesCombinedTwotables}
            selectedColumnsCombined={rightListColumnsValue || selectedSqlEditorNodeData[0].selectedFieldsFromEditor}
            // selectedIdsOnly={idsOnly}
            selectedIdsOnly={rightListColumnsValue || selectedSqlEditorNodeData[0].selectedFieldsFromEditor}
            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            selectedIdsCombinedColumnsValue={node.data.selectedIdsCombinedColumns}
            selectedLabelTypeValue={node.data.selectedLabelType}
          // aliasColumn={selectedDataTableNodeData[0]?.aliasColumnNames || ''}
          // windowFunctionWithCondition={selectedDataTableNodeData[0]?.windowFunctionWithCondition}
          />;

        } else {
          // Handle the popup window for filter nodes
          popupContent = piePopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handlePieSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);
        }
      } else {
        popupContent = piePopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handlePieSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);
      }

    } else if ((selectedNodeId).match(/^scatter/)) {
      let selectedDataBaseCombined;
      let selectedTableCombined;
      let selectedSqlEditorNodeData = '';
      let selectedCurrentTableValue = '';

      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        const sqlEditorNode = nodes.find((node) => node.alt === 'sqlEditor');

        if (dataTableNode || sqlEditorNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const sourceSqlEditorNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log(JSON.stringify(sourceDataTableNodes) + "sourceDataTableNodes" +
            JSON.stringify(sourceSqlEditorNodes) + "sourceSqlEditorNodes");

          if (sourceDataTableNodes.some((node) => node.includes("dataTable"))) {
            const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
            selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
            const columns = selectedCurrentTableValue.columns;
            const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
              return {
                name: data.name,
                catalog: data.catalog,
                dataBaseName: data.selectedDatabase,
                tableName: data.selectedTable,
                //  selectedTableColumns: data.columns,
                selectedTableColumns: data.rightList,
                aliasColumns: data.aliasColumnNames
              };
            });

            console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValues");

            selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
            selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
            const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);
            const aliasColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.aliasColumns);
            let selectedTableColumnsValuesCombinedTwotables = '';
            let idsOnly = '';
            if (selectedTableColumnsValuesCombined) {

              selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined, ...aliasColumnsValuesCombined);
              selectedRightListColumnsValue = selectedTableColumnsValuesCombinedTwotables.map(column => column.split('.').pop());


              idsOnly = selectedTableColumnsValuesCombinedTwotables.filter(column => column.endsWith("_id"));
            }


            console.log(JSON.stringify(idsOnly) + "idsss");
            console.log(selectedTableColumnsValuesCombined);
            console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
            console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
            console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");


          } else if (sourceSqlEditorNodes.some((node) => node.includes("sqlEditor"))) {
            selectedSqlEditorNodeData = sourceSqlEditorNodes.map(nodeId => nodeData[nodeId]);
            //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
            console.log(JSON.stringify(selectedSqlEditorNodeData) + "selectedSqlEditorNodeData");

          }

          // Handle the popup window for filter nodes
          popupContent = <ScatterChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleScatterSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined || ''}
            selectedCurrentTablesCombined={selectedTableCombined || ''}
            selectedColumnsCombined={selectedRightListColumnsValue || selectedSqlEditorNodeData[0].selectedFieldsFromEditor}

            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            leftListValue={node.data.leftList}
            rightListValue={node.data.rightList}
            verticalLabelValue={node.data.verticalLabel}
            horizantalLabelValue={node.data.horizantalLabel}
            selectedCurrentTable={selectedCurrentTableValue || selectedSqlEditorNodeData[0].editorTable}
            selectedPreviousTable={node.data.selectedCurrentTable}
          />;
        } else {

          popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

        }
      } else {
        popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

      }


    }
    else if ((selectedNodeId).match(/^boxWhisker/)) {


      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        if (dataTableNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
          const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
          const columns = selectedCurrentTableValue.columns;
          const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
            return {
              name: data.name,
              catalog: data.catalog,
              dataBaseName: data.selectedDatabase,
              tableName: data.selectedTable,
              // selectedTableColumns: data.columns,
              selectedTableColumns: data.rightList,
            };
          });

          console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValues");

          const selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
          const selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
          const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);
          let selectedTableColumnsValuesCombinedTwotables = '';
          let idsOnly = '';
          if (selectedTableColumnsValuesCombined) {

            selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined);

            idsOnly = selectedTableColumnsValuesCombinedTwotables.filter(column => column.endsWith("_id"));
          }


          console.log(JSON.stringify(idsOnly) + "idsss");
          console.log(selectedTableColumnsValuesCombined);
          console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
          console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
          console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");


          // Handle the popup window for filter nodes
          popupContent = <BoxWhiskerChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}

            onValueSubmit={handleBoxWhiskerSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined}
            selectedCurrentTablesCombined={selectedTableCombined}
            selectedColumnsCombined={selectedTableColumnsValuesCombinedTwotables}
            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            leftListValue={node.data.leftList}
            rightListValue={node.data.rightList}
            verticalLabelValue={node.data.verticalLabel}
            horizantalLabelValue={node.data.horizantalLabel}
          />;
        } else {

          popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

        }
      } else {
        popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

      }


    } else if ((selectedNodeId).match(/^heatMap/)) {


      const connectedToSource = edges.some((edge) => {
        const isTargetMatch = edge.target === selectedNodeId;
        const sourceNode = nodes.find((n) => n.id === edge.source);
        console.log(JSON.stringify(sourceNode) + "sourceNode");
        return isTargetMatch && sourceNode;
      });

      if (connectedToSource) {
        const dataTableNode = nodes.find((node) => node.alt === 'dataTable');
        if (dataTableNode) {

          const sourceDataTableNodes = getSourcesOfJoinNode(selectedNodeId, edges);
          console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE FILTERNODES :" + sourceDataTableNodes);

          const selectedDataTableNodeData = sourceDataTableNodes.map(nodeId => nodeData[nodeId]);
          //  alert(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          console.log(JSON.stringify(selectedDataTableNodeData) + "selectedDataTableNodeData");
          const selectedCurrentDatabase = selectedDataTableNodeData[0]?.selectedDatabase;
          const selectedCurrentTableValue = selectedDataTableNodeData[0]?.selectedTable;
          const columns = selectedCurrentTableValue.columns;
          const selectedTableColumnsValues = selectedDataTableNodeData.map((data) => {
            return {
              name: data.name,
              catalog: data.catalog,
              dataBaseName: data.selectedDatabase,
              tableName: data.selectedTable,
              selectedTableColumns: data.columns,
            };
          });

          console.log(JSON.stringify(selectedTableColumnsValues) + "selectedTableColumnsValues");

          const selectedDataBaseCombined = selectedTableColumnsValues.map((data) => data.dataBaseName);
          const selectedTableCombined = selectedTableColumnsValues.map((data) => data.tableName);
          const selectedTableColumnsValuesCombined = selectedTableColumnsValues.map((data) => data.selectedTableColumns);
          let selectedTableColumnsValuesCombinedTwotables = '';
          let idsOnly = '';
          if (selectedTableColumnsValuesCombined) {

            selectedTableColumnsValuesCombinedTwotables = [].concat(...selectedTableColumnsValuesCombined);

            idsOnly = selectedTableColumnsValuesCombinedTwotables.filter(column => column.endsWith("_id"));
          }


          console.log(JSON.stringify(idsOnly) + "idsss");
          console.log(selectedTableColumnsValuesCombined);
          console.log(JSON.stringify(selectedDataBaseCombined) + "selectedDataBaseCombined");
          console.log(JSON.stringify(selectedTableCombined) + "selectedTableCombined");
          console.log(JSON.stringify(selectedTableColumnsValuesCombined) + "selectedTableColumnsValuesCombined");


          // Handle the popup window for filter nodes
          popupContent = <HeatMapChartPopupComponent onClose={closePopup}
            onRemoveTable={handleRemoveTable}
            selectedNodeId={selectedNodeId}
            nodeName={node.data.label}
            onValueSubmit={handleBoxWhiskerSubmit}
            setNodes={setNodes} // Pass the callback function as a prop
            nodes={nodes} // Pass the nodes array as a prop
            droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
            setDroppedNodes={setDroppedNodes}
            selectedCurrentDatabasesCombined={selectedDataBaseCombined}
            selectedCurrentTablesCombined={selectedTableCombined}
            selectedColumnsCombined={selectedTableColumnsValuesCombinedTwotables}
            selectedCombinedColumnsValue={node.data.selectedCombinedColumns}
            leftListValue={node.data.leftList}
            rightListValue={node.data.rightList}
            verticalLabelValue={node.data.verticalLabel}
            horizantalLabelValue={node.data.horizantalLabel}
          />;
        } else {

          popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

        }
      } else {
        popupContent = scatterPopupContent(selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes);

      }


    }
    setShowPopup(true);
    setPopupContent(popupContent);

  };

  useEffect(() => {
    console.log("Updated droppedNodes:", droppedNodes);
  }, [droppedNodes]);

  const handleDeleteSelectedNodes = (selectedNodeId) => {

    const selectedNodeIdToString = JSON.stringify(selectedNodeId);
    console.log(selectedNodeIdToString + "selectedNodeIdToString");

    const updatedNodes = nodes.filter((node) => node.id !== selectedNodeId);

    const updatedDroppedNodes = droppedNodes.filter((node) => node !== selectedNodeId);

    console.log(JSON.stringify(updatedNodes) + "updatedNodes11111");
    const updatedEdges = edges.filter(
      (edge) => edge.source !== selectedNodeId && edge.target !== selectedNodeId
    );
    // Find the index of the selected node in the nodes array
    const deletedIndex = nodes.findIndex((node) => node.id === selectedNodeId);

    console.log(deletedIndex + "deletedIndex");
    console.log(JSON.stringify(updatedEdges) + "updatedEdges2222222");
    setNodes(updatedNodes);
    // Update droppedNodes using the callback approach
    //setDroppedNodes((prevDroppedNodes) => prevDroppedNodes.filter(node => node.id !== selectedNodeId));

    setDroppedNodes(updatedDroppedNodes);

    setEdges(updatedEdges);
    setFormSubmitted(false);

    // Store the deleted index in a variable for later use
    console.log(JSON.stringify(updatedDroppedNodes) + "updatedDroppedNodes");

    const isPieDropped = droppedNodes.some((node) => node.includes("pie"));
    const isDataTableDropped = droppedNodes.some((node) => node.includes("dataTable"));

    if (!isPieDropped) {
      setFormSubmitted(false);
      setShowCharts(false);
      // setFormDataTableSubmitted(false);
    }
    if (!isDataTableDropped) {

      setFormDataTableSubmitted(false);
      setFormSubmitted(false);
      setShowCharts(false);
    }

  };

  const handleElementsRemove = (elementsToRemove) => {

    const removeElementIds = elementsToRemove.map((element) => element.id);
    setNodes((prevNodes) => prevNodes.filter((node) => !removeElementIds.includes(node.id)));
    setEdges((prevEdges) => prevEdges.filter((edge) => !removeElementIds.includes(edge.id)));

  };

  const handleSelectionChange = (elements) => {
    // Find the selected edge among the elements
    setSelectedElements(elements);
  };


  const handleNodeClick = (event, nodeId) => {

    setSelectedNodeId(nodeId.id);
    if ((nodeId.id).match(/^dataTable/)) {
      console.log("selectedDataTableNode::44");
      setFormDataTableSubmitted(true);
    }
    // else{
    //   setFormDataTableSubmitted(true);
    // }

    if ((nodeId.id).match(/^pie/)) {
      setFormSubmitted(true);

    }

  };

  useEffect(() => {

    const handleKeyDown = (event) => {

      const { source, target } = event;
      if (event.key === 'Delete' && selectedNodeId) {

        event.preventDefault();
        handleDeleteSelectedNodes(selectedNodeId);
        setSelectedNodeId(null);
      }
      if (event.key === 'Delete' && selectedEdgeId) {
        event.preventDefault();
        handleRemoveEdge(selectedEdgeId);
      }

    };
    console.log(JSON.stringify(droppedNodes) + "EDGESONDROP");

    console.log(JSON.stringify(setNodes) + "SETNODES");
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };

  }, [selectedNodeId, selectedEdgeId, droppedNodes]);


  const handleShow = async (e) => {
    console.log("In handle show selectedNodeId1::", selectedNodeId)
    console.log("SQL-1::");
    setSelectedNodeId(selectedNodeId);
    // e.preventDefault();
    const sqlArray = [];
    const buildInsertTableNameArray = [];
    const buildCreateTableNameArray = [];
    const buildTableNameArray = [];
    const orderByArray = [];
    const buildWhereArray = [];
    const buildJoinArray = [];
    const buildSelectArray = [];
    const buildGroupByArray = [];
    const buildWindowFunctionArray = [];
    let selectedWindowFunctions;
    let selectedColumnsFound = false; // Flag to track if selected columns are found
    let selectedGroupByColumnsValues;
    let selectedDatabasesArray = [];
    //setSqlQuery(' ')
    if (execSqlStatement==true) {
      setLoading(true);
        try {
          const SQL = await generateSQLData(sqlDirectQuery);
          console.log("sqlDirectQuery::", sqlDirectQuery);
          console.log("SQL-20::" + JSON.stringify(SQL));
          console.log(JSON.stringify(SQL.length) + "SQL-LENGTH");
          if (SQL["data"]!=undefined){
          setGridData(SQL["data"]);
          } else if (SQL.error != undefined) {
            setError(SQL.error); // Optionally show a success message
            setShowErrorPopup(true);
          }
          execSqlStatement = false;
          //setSqlQuery(SQL);

        } catch (error) {
          console.log('SQL-20::Error fetching dropdown options:', error);
        }
    } else {
      console.log("SQL-30::");
      let isJoinNodePresent = false;

      const sourcesAndTargets = [];
      let individualOrCombinedNodes = [];
      for (const item of edges) {
        const source = item.source;
        const target = item.target;
        sourcesAndTargets.push({ source, target });
      }

      console.log(JSON.stringify(sourcesAndTargets) + "sourcesAndTargets");
      // console.log(JSON.stringify(sourcesAndTargets[0].source) + "sourcesAndTargetsSOURCE");
      const droppedSourcesAndTargets = Array.from(
        new Set(
          sourcesAndTargets.map(item => [item.source, item.target]).flat()
        )
      );
      console.log(JSON.stringify(droppedSourcesAndTargets) + "droppedSourcesAndTargets");

      const joinNodes = droppedSourcesAndTargets.filter(node => node.startsWith("join_"));

      //  const sourceDataTableNodes = getSourcesOfJoinNode(joinNodes, edges);
      const sourceDataTableNodes = joinNodes.map(joinNode => {
        const sources = getSourcesAllNodes(joinNode, edges);
        return { joinNode, sources };

      });
      console.log("TRAVERSE EDGES CONNECTION UNTIL DOUBLECLICK THE NODES:" + JSON.stringify(sourceDataTableNodes));

      console.log(JSON.stringify(droppedSourcesAndTargets) + "droppedSourcesAndTargets");
      if (droppedSourcesAndTargets.length > 0) {
        individualOrCombinedNodes = droppedSourcesAndTargets;
      } else {
        individualOrCombinedNodes = droppedNodes;
      }


      // Initialize a Set to store unique sources
      const uniqueSources = new Set();

      // Iterate through each object in sourceDataTableNodes
      sourceDataTableNodes.forEach((node) => {
        const sourcesFromData = node.sources;

        // Add each source to the uniqueSources Set
        sourcesFromData.forEach((source) => {
          uniqueSources.add(source);
        });
        // Also, add the joinNode value to the Set
        uniqueSources.add(node.joinNode);
        droppedSourcesAndTargets.forEach((remainingnodes) => {
          uniqueSources.add(remainingnodes);
        })

      });

      // Convert the Set back to an array to get unique sources
      const allUniqueSources = Array.from(uniqueSources);

      console.log(JSON.stringify(allUniqueSources) + "allUniqueSources");

      let nodesToProcess = allUniqueSources;

      // Check if the join node is present in allUniqueSources
      const joinNodePresent = allUniqueSources.some(node => node.startsWith("join_"));

      // If join node is not present, use droppedSourcesAndTargets instead
      if (!joinNodePresent && individualOrCombinedNodes.length > 0) {
        nodesToProcess = individualOrCombinedNodes;
      }

      let aliasCount = 1; // Initialize a counter
      let selectedColumns = [];
      setLoading(true);

      individualOrCombinedNodes.forEach((droppedNodeId) => {

        const droppedNode = nodes.find((node) => node.id === droppedNodeId);
        console.log(JSON.stringify(droppedNode) + "droppedNodeALT");

        if (droppedNode) {

          if (droppedNode.data.jsonCreateTableData) {


            if (droppedNode.data.isTableDropdownExists) {
              buildInsertTableNameArray.push(droppedNode.data.jsonCreateTableData);
            } else {
              buildCreateTableNameArray.push(droppedNode.data.jsonCreateTableData);
            }
          }
          console.log(JSON.stringify(buildCreateTableNameArray) + "buildCreateTableNameArray");
          console.log(JSON.stringify(buildInsertTableNameArray) + "buildInsertTableNameArray");
          console.log(JSON.stringify(buildCreateTableNameArray.length) + "buildCreateTableNameArrayLENGTH");
          console.log(JSON.stringify(buildInsertTableNameArray.length) + "buildInsertTableNameArrayLENGTH");
          console.log(JSON.stringify(droppedNode) + "droppedNode111::",selectedNodeId);

          if (droppedNode.data.selectedDatabase && droppedNode.data.selectedTable) {
            //  const alias = `Alias${aliasCount++}`; 
            if (connectionTypeValue !== 'SQLite') {
              buildTableNameArray.push({ buildTableName: `${droppedNode.data.catalog}.${droppedNode.data.selectedDatabase}.${droppedNode.data.selectedTable}` });

            } else {
              selectedDatabasesArray.push(droppedNode.data.selectedDatabase);
              buildTableNameArray.push({ buildTableName: `${droppedNode.data.selectedTable}` });

            }
            // buildTableNameArray.push({ buildTableName: `${droppedNode.data.catalog}.${droppedNode.data.selectedDatabase}.${droppedNode.data.selectedTable}` });
            //sqlArray.push({ buildTableName: `${droppedNode.data.selectedDatabase.name}.${droppedNode.data.selectedTable.name}` });
          }
          console.log(JSON.stringify(buildTableNameArray) + "buildTableNameArray");



          // alert(JSON.stringify(droppedNode.data.rightList)+"RIGHTLISTVALUES");
          // const selectedGroupByColumns = droppedNode.data.selectedRightlistColumns; //important code from selectnodepopup
          const selectedGroupByColumns = droppedNode.data.selectedAliasFunctionColumns;
          if (selectedGroupByColumns) {

            selectedGroupByColumnsValues = selectedGroupByColumns.join(",");

          }

          if (droppedNode.alt !== 'Line Chart' && droppedNode.alt !== 'Pie Chart' &&
            droppedNode.alt !== 'Scatter' && droppedNode.alt !== 'Bar') {

            selectedColumns = droppedNode.data.rightList;
           
            if (selectedColumns && selectedColumns.length > 0) {
              console.log("In selectedColumns:11")
              //const buildSelectedColumns = selectedColumns.join(", ")
              var col_list = []
              var json_attr = [];
              var table_name = '';
              var col_str = '';
              var col_final_list = [];
              console.log("In selectedColumns:22", selectedColumns);
              for (let i = 0; i < selectedColumns.length; i++) {
                console.log("In selectedColumns:33", selectedColumns[i],selectedColumns[i].split("_message"));
                if (selectedColumns[i].includes("_message") && !selectedColumns[i].includes("_message_corrupt") && !selectedColumns[i].includes("_message_length") && selectedColumns[i].split("_message").length > 1 && selectedColumns[i].split("_message").length > 1 && selectedColumns[i].split("_message")[1]!='') {
                  const selectedColumn = selectedColumns[i]
                  console.log("In selectedColumns:44");
                  json_attr = selectedColumns[i].split("_message")[1].split("_");
                  table_name = selectedColumns[i].split("_message")[0]
                  console.log("In selectedColumns:55", json_attr, table_name);
      
                  for (let n = 0; n < json_attr.length; n++) {
                    //json_extract_scalar(_message, '$.partKey')
                    console.log("In selectedColumns:77", json_attr[n], selectedColumn);
                    if (json_attr[n]!='') {
                    //col_str += '.' + json_attr[i]
                      col_final_list = col_final_list.concat("json_extract_scalar(" + table_name + "_message, '$." + json_attr[n] + "') AS " + "_message_" + json_attr[n])
                      console.log("In selectedColumns:88", col_final_list);
                    }
                  }
                  //col_final_str = "json_extract_scalar(" + table_name + "_message, '$'" + col_str + "')"
                  //col_list += col_final_str
                } else {
                  col_final_list = col_final_list.concat(selectedColumns[i])
                }
              }
              
              //const buildSelectedColumns = selectedColumns.join(", ")
              console.log("In selectedColumns:99", col_final_list);
              //const buildSelectedColumns = col_final_list.join(", ")

              console.log("In selectedColumns:100", col_final_list.join(", "));
              buildSelectArray.push(col_final_list.join(", "));
              selectedColumnsFound = true;
              console.log(JSON.stringify(droppedNode.data.selectedRightlistColumns) + "droppedNode.data.selectedRightlistColumns");
              console.log(JSON.stringify(buildSelectArray) + "sqlArrayINSIDE SELECTNODE");

              console.log(selectedColumnsFound);
            }
          }

          selectedWindowFunctions = droppedNode.data.appendWindowFunction;
          console.log("In buildelect::-10",selectedWindowFunctions)
          if (selectedWindowFunctions && selectedWindowFunctions.length > 0) {
            // const buildSelectedWindowFunctions = selectedWindowFunctions.join(", ");
            buildWindowFunctionArray.push(selectedWindowFunctions);
            // selectedWindowFunctions = selectedWindowFunctions.join(", ");
          }
          console.log(JSON.stringify(selectedColumns) + "selectedColumns123");


          const { dataFilterJson } = droppedNode.data;
          if (dataFilterJson !== undefined) {
            console.log(JSON.stringify(dataFilterJson) + "dataFilterJson");
            buildWhereArray.push(dataFilterJson);
          }
          const { buildOrderBy } = droppedNode.data;
          console.log(JSON.stringify(buildOrderBy) + "buildOrderBy");
          if (buildOrderBy && buildOrderBy.length > 0) {

            orderByArray.push(buildOrderBy);
          }
          console.log("DROPPED::1", JSON.stringify(droppedNode.data));
          const { buildJoin } = droppedNode.data;
          console.log("buildJoin::1",JSON.stringify(buildJoin));
          if (buildJoin !== undefined) {
            //  isJoinNodePresent = true;
            console.log("buildjoin::2");
            //  buildJoinArray.push({ buildJoin: [buildJoin] });
            buildJoinArray.push(buildJoin);

          }
        }

      });
      console.log(JSON.stringify(buildWhereArray) + "1buildWhereArray");
      console.log("buildJoinArray::1",JSON.stringify(buildJoinArray));
      console.log(JSON.stringify(buildGroupByArray) + "buildGroupByArray");
      console.log("selectedColumnsFound::1", selectedColumnsFound);

      if (!selectedColumnsFound && buildWindowFunctionArray.length === 0) {
        if (buildCreateTableNameArray && buildCreateTableNameArray.length > 0) {
          sqlArray.push({ buildCreateTableAs: buildCreateTableNameArray[0] });
        } else if (buildInsertTableNameArray && buildInsertTableNameArray.length > 0) {
          sqlArray.push({ buildInsertTableAs: buildInsertTableNameArray[0] });
        }
        /*
        if (connectionTypeValue = "kafka") {
          sqlArray.push({ buildSelect: dropdownColumns.map(column => column[0]) });
        } else {
          sqlArray.push({ buildSelect: "*" });
        }
        */
        //console.log("droppedNode.data.selectedRightlistColumns::3", droppedNode.data.selectedRightlistColumns);
        console.log("droppedNode.data.selectedRightlistColumns::3")
        sqlArray.push({ buildSelect: "*" });
        //console.log("sqlArray::10", leftList, sqlArray);
      } else {

        console.log(JSON.stringify(buildSelectArray) + "buildSelectArray");
        const buildSelectString = buildSelectArray.join(", ");
        console.log(JSON.stringify(buildSelectString) + "buildSelectString");

        if (buildWindowFunctionArray.length > 0)  {
          if (buildCreateTableNameArray && buildCreateTableNameArray.length > 0) {

            sqlArray.push({ buildCreateTableAs: buildCreateTableNameArray[0] });
          } else if (buildInsertTableNameArray && buildInsertTableNameArray.length > 0)   {
            sqlArray.push({ buildInsertTableAs: buildInsertTableNameArray[0] });
          }
          console.log("buildelect::-11", buildWindowFunctionArray.length)
          let selectedWindowFunctions='';
          if (buildWindowFunctionArray.length>0) {
            console.log("buildelect::-121", isSelectedWindowFunction, windowFunctionsList)
            //selectedWindowFunctions = buildWindowFunctionArray.join(", ");
            const filterWindowFunctionArray = windowFunctionsList.filter((_, index) => isSelectedWindowFunction?.[index] === true);
            //const filterWindowFunctionArray = buildWindowFunctionArray.filter((_, index) => isSelectedWindowFunction?.[index] === true);
            selectedWindowFunctions = filterWindowFunctionArray.join(", ");
            console.log("buildelect::-12", filterWindowFunctionArray, selectedWindowFunctions)
          } 
        
          if (buildSelectArray.length > 0) {
            console.log("buildelect::-2", selectedWindowFunctions, buildSelectArray)
            const filterWindowFunctionArray = windowFunctionsList.filter((_, index) => isSelectedWindowFunction?.[index] === true);
            //if (filterWindowFunctionArray.length)
            selectedWindowFunctions = filterWindowFunctionArray.join(", ");
            
            if (!selectedWindowFunctions){
              console.log("buildelect::-3", buildSelectString,selectedWindowFunctions)
              sqlArray.push({ buildSelect: `${buildSelectString}` });
            } else  {
              console.log("buildelect::-4", buildSelectString, selectedWindowFunctions, isSelectedWindowFunction)
              //let appendedBuildSelectString='';
              
              /*
              if (isSelectedWindowFunction?.["first"]){
                console.log("buildelect::-45", selectedWindowFunctions)
                appendedBuildSelectString = `${buildSelectString}, ${selectedWindowFunctions}`;
              } else {
                appendedBuildSelectString = `${buildSelectString}`;
              }
              */
             
              const appendedBuildSelectString = `${buildSelectString}, ${selectedWindowFunctions}`;
              sqlArray.push({ buildSelect: `${appendedBuildSelectString}` });
            }
            
          } else {
            console.log("buildelect::-5", JSON.stringify(selectedWindowFunctions))
            let appendedBuildSelectString;
            if (!selectedWindowFunctions && selectedWindowFunctions=="") {
            console.log("buildelect::-6", selectedWindowFunctions)
            appendedBuildSelectString = `${selectedWindowFunctions}`;
            //sqlArray.push({ buildSelect: appendedBuildSelectString });
              sqlArray.push({ buildSelect: "*" });
            } else {
              //if (isSelectedWindowFunction?.["first"]){
              console.log("buildelect::-46", buildSelectString, selectedWindowFunctions)
              appendedBuildSelectString = `${selectedWindowFunctions}`;
              sqlArray.push({ buildSelect: appendedBuildSelectString });
              //} 
            }
          }

        } else {
          if (buildCreateTableNameArray && buildCreateTableNameArray.length > 0) {
            sqlArray.push({ buildCreateTableAs: buildCreateTableNameArray[0] });
          } else if (buildInsertTableNameArray && buildInsertTableNameArray.length > 0) {
            sqlArray.push({ buildInsertTableAs: buildInsertTableNameArray[0] });
          }
          const appendedBuildSelectString1 = `${buildSelectString}`;
          sqlArray.push({ buildSelect: appendedBuildSelectString1 });
        }

        //  sqlArray.push({ buildSelect: JSON.stringify(buildSelectArray)});
      }
      let firstTableName = { buildTableName: '' };
      let secondTableName = { buildTableName: '' };
      if (buildTableNameArray.length > 0 && buildJoinArray.length > 0) {
        console.log(JSON.stringify(buildTableNameArray) + "buildTableNameArray");
        const val = JSON.stringify(buildJoinArray[0].joinTable1);
        console.log(JSON.stringify(val) + "val");
        console.log(JSON.stringify(buildJoinArray[0].joinTable1) + "buildJoinArrayjoinTable1");

        //firstTableName = buildJoinArray[0].joinTable1;
        firstTableName = `${buildTableNameArray[0].buildTableName}`;
        //  firstTableName = `${buildTableNameArray[0].buildTableName} AS A${aliasCount++}`;
        //const firstTableName = buildTableNameArray[0];

        sqlArray.push({ buildTableName: firstTableName });

        if (buildJoinArray.length > 0) {
          console.log(JSON.stringify(buildJoinArray) + "buildJoinArray");

          // Modify the buildJoinArray to set aliases for joinTable1 and joinTable2
          const modifiedBuildJoinArray = buildJoinArray.map((joinItem, index) => {
            const aliasA2 = joinItem.joinTable1 === joinItem.joinTable2 ? `A${index + 1}` : '';
            const columnDetails = JSON.parse(joinItem.columnDetails);


            const modifiedColumnDetails = columnDetails.map((columnDetail) => ({
              ...columnDetail,
              table1Column: `${columnDetail.table1Column}`,
              table2Column: `${columnDetail.table2Column}`,
            }));

            return {
              ...joinItem,
              joinTable1: `${joinItem.joinTable1}`,
              joinTable2: aliasA2 ? `${joinItem.joinTable2} AS ${aliasA2}` : `${joinItem.joinTable2}`,
              columnDetails: JSON.stringify(modifiedColumnDetails),
            };
          });

          console.log(JSON.stringify(modifiedBuildJoinArray) + "modifiedBuildJoinArray");

          sqlArray.push({ buildJoin: JSON.stringify(modifiedBuildJoinArray) });
        }

      } else {
        sqlArray.push(...buildTableNameArray);
      }

      if (buildWhereArray.length > 0) {
        const dataFilterJson1 = {
          buildWhere: JSON.stringify(buildWhereArray)
        };
        sqlArray.push(dataFilterJson1);

      }
      if (selectedGroupByColumnsValues && selectedGroupByColumnsValues.length > 0) {
        sqlArray.push({ buildGroup: selectedGroupByColumnsValues });
      }
      if (orderByArray.length > 0) {
        const combinedBuildOrderBy = orderByArray.join(', ');
        sqlArray.push({ buildOrderBy: combinedBuildOrderBy });
      }

      console.log("firstsqlArray::1",JSON.stringify(sqlArray), selectedNodeId);

      setSqlJsonData(sqlArray);

      try {
        //const token = await fetchToken();
        const generateSqlQueryData = await generateSqlQuery(sqlArray);
        console.log(JSON.stringify(generateSqlQueryData) + "generateSqlQueryData");

        if (generateSqlQueryData && connectionTypeValue !== 'SQLite') {
          try {

            const SQL = await generateSQLData(generateSqlQueryData);
            const { data, columns, requestBody } = SQL;
            if (SQL.error) {
              // Handle the error
              console.error('Error generating SQL data:11', requestBody ,SQL.error);
              setGridData([]);
              setGridDataColumns([]);
              setSqlQuery(generateSqlQueryData);
              setError(SQL.error); // Optionally show a success message
              setShowErrorPopup(true);


            } else {
              console.log(JSON.stringify(data) + "griddata");
              console.log(JSON.stringify(columns) + "columns");
              console.log(JSON.stringify(SQL) + "SQL");
              console.log(JSON.stringify(SQL.length) + "SQL-LENGTH");

              if (data !== null && columns !== null) {
                setGridData(data);
                setGridDataColumns(columns);
                //setSqlQuery(requestBody);
              }
              setSqlQuery(requestBody);
            }


          } catch (error) {
            console.error('Error fetching dropdown options:', error);
          }

        } else {
          try {
            // Initialize arrays to store keys and values
            const keys = [];
            const values = [];

            const SQL = await generateSqliteQueryResponse(selectedDatabasesArray, generateSqlQueryData);
            console.log(JSON.stringify(SQL) + "RESPONSESQLite");
            if (SQL.error) {
              // Handle the error response
              console.error('Error in SQL response:', SQL.error);
              setGridData([]);
              setGridDataColumns([]);
              setError(SQL.error); // Optionally show a success message
              setShowErrorPopup(true);
              // You can display an error popup or message to the user here
            } else {
              // Filter out extraneous commas and convert to the desired format
              const gridDataValue = SQL
                .filter(item => item !== ",") // Filter out commas
                .map(item => {
                  return JSON.parse(item); // Parse each record
                  // return Object.values(parsedData); // Get values as an array
                });
              // Iterate through the JSON objects in the array
              gridDataValue.forEach((data) => {
                const objectKeys = Object.keys(data);
                const objectValues = Object.values(data);

                keys.push(objectKeys);
                values.push(objectValues);
              });
              console.log(JSON.stringify(keys) + "keys");
              console.log(JSON.stringify(values) + "values");
              console.log(JSON.stringify(gridDataValue) + "gridDataValue");
              console.log(JSON.stringify(gridDataValue) + "griddata");
              console.log(JSON.stringify(gridDataValue) + "SQL");
              console.log(JSON.stringify(gridDataValue.length) + "SQL-LENGTH");
              if (keys !== null && values !== null) {
                setGridData(values);
                setGridDataColumns(keys[0]);
              } else {
                setGridData([]);
                setGridDataColumns([]);
              }
            }

          } catch (error) {
            console.error('Error fetching dropdown options:', error);

            setError(error); // Optionally show a success message
            setShowErrorPopup(true);
            //  setGridData([]);
            //  setGridDataColumns([]);
          }
        }

      } catch (error) {
        console.error('Error fetching connections:', error);

        setError(error); // Optionally show a success message
        setShowErrorPopup(true);
        setGridData([]);
        setGridDataColumns([]);
      }

      console.log(JSON.stringify(droppedNodes) + "droppednodesid");
      console.log(JSON.stringify(nodes) + "nodes");


    }
    console.log("SQL-40::");
    setShowCharts(true);

    console.log(JSON.stringify(nodes) + "NODES");

    // Get the IDs of dropped nodes
    const droppedNodeIds = droppedNodes.map((node) => node.id);
    const isPieDropped = droppedNodes.some((node) => node.includes("pie"));
    const isBarDropped = droppedNodes.some((node) => node.includes("bar"));
    const isLineDropped = droppedNodes.some((node) => node.includes("line"));
    const isDataTableDropped = droppedNodes.some((node) => node.includes("dataTable"));
    const isScatterDropped = droppedNodes.some((node) => node.includes("scatter"));
    const isBoxWhiskerDropped = droppedNodes.some((node) => node.includes("boxWhisker"));
    const dataTableDroppedNodesValue = droppedNodes.filter(node => node.includes("dataTable"));

    const isSqlEditorDropped = droppedNodes.filter((node) => node.includes("sqlEditor"));

    if (isSqlEditorDropped && !isDataTableDropped && !isPieDropped
      && !isBarDropped && !isLineDropped && !isScatterDropped && !isBoxWhiskerDropped) {
      setDataTableDroppedNodes(isSqlEditorDropped);
    }

    if (dataTableDroppedNodesValue.length > 0) {
      if (!isPieDropped && !isBarDropped && !isLineDropped && !isScatterDropped) {
        setDataTableDroppedNodes(dataTableDroppedNodesValue);
      }
    }

    if (isDataTableDropped && !isPieDropped
      && !isBarDropped && !isLineDropped && !isScatterDropped && !isBoxWhiskerDropped) {
      setFormDataTableSubmitted(true);
      setFormSubmitted(false);
      setFormBarSubmitted(false);
      setFormLineSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(true);
    }
    else if (isSqlEditorDropped && !isPieDropped
      && !isBarDropped && !isLineDropped && !isScatterDropped && !isBoxWhiskerDropped) {
      setFormDataTableSubmitted(true);
      setFormSubmitted(false);
      setFormBarSubmitted(false);
      setFormLineSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(true);
    } else if (isPieDropped) {
      setFormSubmitted(true);
      setFormDataTableSubmitted(false);
      setFormBarSubmitted(false);
      setFormLineSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(true);
    } else if (isBarDropped) {
      setFormBarSubmitted(true);
      setFormSubmitted(false);
      setFormDataTableSubmitted(false);
      setFormLineSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(true);
    } else if (isLineDropped) {
      setFormLineSubmitted(true);
      setFormSubmitted(false);
      setFormDataTableSubmitted(false);
      setFormBarSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(true);
    } else if (isScatterDropped) {
      setShowCharts(true);
      setFormScatterSubmitted(true);
      setFormLineSubmitted(false);
      setFormSubmitted(false);
      setFormDataTableSubmitted(false);
      setFormBarSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
    } else if (isBoxWhiskerDropped) {

      setShowCharts(true);
      setFormBoxWhiskerSubmitted(true);
      setFormLineSubmitted(false);
      setFormSubmitted(false);
      setFormDataTableSubmitted(false);
      setFormBarSubmitted(false);
      setFormScatterSubmitted(false);
    }
    else {
      // No chart or data table dropped
      setFormSubmitted(false);
      setFormDataTableSubmitted(false);
      setFormBarSubmitted(false);
      setFormLineSubmitted(false);
      setFormScatterSubmitted(false);
      setFormBoxWhiskerSubmitted(false);
      setShowCharts(false);
    }
    // Filter nodes that are dropped
    const droppedNodesInNodesArray = nodes.filter((node) => droppedNodeIds.includes('pie'));
    setLoading(false);
    console.log("SQL-50::");
    console.log(JSON.stringify(edges) + "HANDLESHOWEDGES");
    console.log(JSON.stringify(nodes) + "HANDLESHOWNODES");
    console.log("SQL-60::");
  }


  const handlePublish = async (e) => {

    setSelectedNodeId(selectedNodeId);
    console.log(JSON.stringify(connectionNameValue) + "connectionNameValue");
    console.log(JSON.stringify(reportName) + "reportName");

    // Get the IDs of dropped nodes
    const droppedNodeIds = droppedNodes.map((node) => node.id);
    const isPieDropped = droppedNodes.some((node) => node.includes("pie"));
    const isBarDropped = droppedNodes.some((node) => node.includes("bar"));
    const isLineDropped = droppedNodes.some((node) => node.includes("line"));
    const isScatterDropped = droppedNodes.some((node) => node.includes("scatter"));
    const isDataTableDropped = droppedNodes.some((node) => node.includes("dataTable"));
    const dataTableDroppedNodesValue = droppedNodes.filter(node => node.includes("dataTable"));
    const isSqlEditorDropped = droppedNodes.filter((node) => node.includes("sqlEditor"));
    const isBoxWhiskerDropped = droppedNodes.some((node) => node.includes("boxWhisker"));


    if (isSqlEditorDropped && !isDataTableDropped && !isPieDropped
      && !isBarDropped && !isLineDropped && !isScatterDropped && !isBoxWhiskerDropped) {
      setDataTableDroppedNodes(isSqlEditorDropped);
    }


    if (dataTableDroppedNodesValue.length > 0) {
      if (isDataTableDropped && !isPieDropped && !isBarDropped && !isLineDropped && !isScatterDropped) {
        setDataTableDroppedNodes(dataTableDroppedNodesValue);
      }
    }

    if (isDataTableDropped && !isPieDropped && !isBarDropped && !isLineDropped && !isScatterDropped) {
      // setDataTableDroppedNodes(dataTableDroppedNodesValue);
      handleDataTableClick(dataTableDroppedNodesValue);

    } else if (isSqlEditorDropped &&
      !isDataTableDropped && !isPieDropped && !isBarDropped && !isLineDropped && !isScatterDropped) {
      handleDataTableClick(isSqlEditorDropped);
    } else if (isPieDropped) {

      //handlePieClick();

    } else if (isBarDropped) {
      handleBarClick();
    } else if (isLineDropped) {
      handleLineClick();
    } else if (isScatterDropped) {
      handleScatterClick();
    }
  };
  useEffect(() => {
    console.log(JSON.stringify(dataTableDroppedNodes) + "dataTableDroppedNodes");
  }, [dataTableDroppedNodes]);

  const handleCreate = async (e) => {
    e.preventDefault();
    const sqlArray = [];
    const buildTableNameArray = [];
    const orderByArray = [];
    const buildWhereArray = [];
    const buildJoinArray = [];
    const buildSelectArray = [];
    const buildGroupByArray = [];
    const buildWindowFunctionArray = [];
    let selectedWindowFunctions;
    let selectedColumnsFound = false; // Flag to track if selected columns are found
    let selectedGroupByColumnsValues;

    droppedNodes.forEach((droppedNodeId) => {
      const droppedNode = nodes.find((node) => node.id === droppedNodeId);
      console.log(JSON.stringify(droppedNode) + "droppedNode");
      if (droppedNode) {
        // alert(JSON.stringify(droppedNode.data.rightList)+"RIGHTLISTVALUES");
        const selectedGroupByColumns = droppedNode.data.selectedRightlistColumns; //important code from selectnodepopup
        if (selectedGroupByColumns) {
          selectedGroupByColumnsValues = selectedGroupByColumns.join(",");
        }
        const selectedColumns = droppedNode.data.rightList;
        selectedWindowFunctions = droppedNode.data.appendWindowFunction;

        if (selectedWindowFunctions) {
          // const buildSelectedWindowFunctions = selectedWindowFunctions.join(", ");
          buildWindowFunctionArray.push(selectedWindowFunctions);
          // selectedWindowFunctions = selectedWindowFunctions.join(", ");
        }


        if (selectedColumns && selectedColumns.length > 0) {
          const buildSelectedColumns = selectedColumns.join(", ");
          buildSelectArray.push(buildSelectedColumns);
          selectedColumnsFound = true;
          console.log("droppedNode.data.selectedRightlistColumns::1",droppedNode.data.selectedRightlistColumns);
          console.log(JSON.stringify(sqlArray) + "sqlArrayINSIDE SELECTNODE");

          console.log(selectedColumnsFound);
        }


        if (droppedNode.data.selectedDatabase && droppedNode.data.selectedTable) {
          buildTableNameArray.push({ buildTableName: `${droppedNode.data.selectedDatabase.name}.${droppedNode.data.selectedTable.name}` });
          //sqlArray.push({ buildTableName: `${droppedNode.data.selectedDatabase.name}.${droppedNode.data.selectedTable.name}` });
        }
        console.log(JSON.stringify(buildTableNameArray) + "buildTableNameArray");

        const { dataFilterJson } = droppedNode.data;
        if (dataFilterJson !== undefined) {
          buildWhereArray.push(dataFilterJson);
        }
        const { buildOrderBy } = droppedNode.data;
        console.log(JSON.stringify(buildOrderBy) + "buildOrderBy");
        if (buildOrderBy) {
          orderByArray.push({ buildOrderBy: buildOrderBy });
        }
        console.log(JSON.stringify(droppedNode.data) + "DROPPED");
        const { buildJoin } = droppedNode.data;
        console.log(JSON.stringify(buildJoin) + "buildJoin");
        if (buildJoin !== undefined) {
          console.log("buildjoin");
          //  buildJoinArray.push({ buildJoin: [buildJoin] });
          buildJoinArray.push(buildJoin);
        }
      }
    });
    console.log(JSON.stringify(buildWhereArray) + "1buildWhereArray");
    console.log(JSON.stringify(buildJoinArray) + "buildJoinArray");
    console.log("buildGroupByArray::", JSON.stringify(buildGroupByArray), buildGroupByArray);
    

    if (!selectedColumnsFound) {
      console.log("buildSelectColumns::1", connectionTypeValue, dropdownColumns)
      /*
      if (connectionTypeValue="kafka") {
        sqlArray.push({ buildSelect: dropdownColumns.map(column => column[0]) });
      } else {
        sqlArray.push({ buildSelect: "*" });
      }
      */
      //  console.log("droppedNode.data.selectedRightlistColumns::2", droppedNode.data.selectedRightlistColumns);
      sqlArray.push({ buildSelect: "*" });
      console.log(JSON.stringify(sqlArray) + "sqlArray:111");
    } else {
      console.log(JSON.stringify(buildSelectArray) + "buildSelectArray");
      const buildSelectString = buildSelectArray.join(", ");
      console.log(JSON.stringify(buildSelectString) + "buildSelectString");
      // alert(JSON.stringify(buildSelectString) + "buildSelectString");
      if (buildWindowFunctionArray.length > 0) {
        console.log("buildSelect::11", buildWindowFunctionArray, selectedWindowFunctions)
        //const appendedBuildSelectString = `${buildSelectString}, ${selectedWindowFunctions}`;
        const appendedBuildSelectString = `${buildSelectString}`;
        sqlArray.push({ buildSelect: appendedBuildSelectString });

      } else {
        console.log("buildSelect::22", buildSelectString)
        const appendedBuildSelectString1 = `${buildSelectString}`;
        sqlArray.push({ buildSelect: appendedBuildSelectString1 });
      }

      //  sqlArray.push({ buildSelect: JSON.stringify(buildSelectArray)});
    }
    let firstTableName = { buildTableName: '' };
    if (buildTableNameArray.length > 0 && buildJoinArray.length > 0) {
      console.log(JSON.stringify(buildTableNameArray) + "buildTableNameArray");
      const val = JSON.stringify(buildJoinArray[0].joinTable1);
      console.log(JSON.stringify(val) + "val");
      console.log(JSON.stringify(buildJoinArray[0].joinTable1) + "buildJoinArrayjoinTable1");

      //firstTableName = buildJoinArray[0].joinTable1;
      firstTableName = buildTableNameArray[0].buildTableName;
      //const firstTableName = buildTableNameArray[0];

      sqlArray.push({ buildTableName: firstTableName });

      // sqlArray.push(...builJdTableNameArray);

    } else {
      sqlArray.push(...buildTableNameArray);
    }

    if (buildJoinArray.length > 0) {
      sqlArray.push({ buildJoin: JSON.stringify(buildJoinArray) });
    }

    if (buildWhereArray.length > 0) {
      const dataFilterJson1 = {
        buildWhere: JSON.stringify(buildWhereArray)
      };
      sqlArray.push(dataFilterJson1);

    }
    if (selectedGroupByColumnsValues && selectedGroupByColumnsValues.length > 0) {
      sqlArray.push({ buildGroup: selectedGroupByColumnsValues });
    }
    if (orderByArray.length > 0) {
      sqlArray.push(...orderByArray);
    }

    console.log(JSON.stringify(sqlArray) + "firstsqlArray");
    console.log(JSON.stringify(sqlArray) + "sqlArray::22");
    // alert(JSON.stringify(sqlArray)+"sqlArray");
    
    try {
      //const token = await fetchToken();
      const generateSqlQueryData = await generateSqlQuery(sqlArray);
      console.log(JSON.stringify(generateSqlQueryData) + "generateSqlQueryData");
    } catch (error) {
      console.error('Error fetching connections:', error);
    }

    console.log(JSON.stringify(droppedNodes) + "droppednodesid");

    // Combine the reportName with the existing formData

    console.log(JSON.stringify(eachReportDetails) + "eachReportDetails");
    let oldReportData = '';
    if (eachReportDetails) {
    const newReport = {
        reportName: reportName,
        reportDescription: reportDescription,
        nodes,
        edges,
        droppedNodes,
        nodeData
      };

      try {
        //const token = await fetchToken();
        const newReportData = await createNewReport(eachReportDetails.connectionName, reportName, newReport,localStorage.getItem('orgName'));

        console.log("READ EACH REPORT DATA : " + JSON.stringify(newReportData));
      } catch (error) {
        console.error('Error fetching connections:', error);
      }

      // Successful save
      setIsSaved(true);
      setError('State saved successfully.'); // Optionally show a success message
      setShowErrorPopup(true);
      navigate('/ReportDetails', { state: { connectionName: eachReportDetails.connectionName, connectionType: connectionTypeValue } });
      // window.location.reload();
    }
  };

  const handleEdgeClick = (edgeId) => {
    //alert(JSON.stringify(edgeId));
    if (selectedEdgeId === edgeId) {
      setSelectedEdgeId(null); // Deselect if the same edge is clicked again
    } else {
      getEdgeStyle(edgeId);
      setSelectedEdgeId(edgeId);
    }

  };

  const handleRemoveEdge = (selectedEdgeId) => {
    // alert();
    if (selectedEdgeId) {
      const updatedEdges = edges.filter((edge) => edge.id !== selectedEdgeId);
      setEdges(updatedEdges);
      setSelectedEdgeId(null);
    }
  };



  const deleteEdge = (edgeId) => {
    // Filter the edges array to remove the edge with the specified ID
    const updatedEdges = edges.filter(edge => edge.id !== edgeId);

    // Update the state with the updated edges array
    setEdges(updatedEdges);
  };

  const sqlJsonDataFileSave = async (sqlJsonData, gridData) => {
    try {
      //const token = await fetchToken();

      // Create the chart report with sqlPayload
      const sqlPayloadReport = {
        sqlJsonData,
      };
      const sqlPayloadResult = await createNewChartReport(eachReportDetails.connectionName, reportName, sqlPayloadReport, '_sqlPayload',localStorage.getItem('orgName'));
      console.log("Created SQL Payload Report:", sqlPayloadResult);

      // Create the chart report with gridData
      const gridDataReport = {
        gridData,
      };
      const gridDataResult = await createNewChartReport(eachReportDetails.connectionName, reportName, gridDataReport, '_chart',localStorage.getItem('orgName'));
      console.log("Created Grid Data Report:", gridDataResult);
    } catch (error) {
      console.error('Error fetching connections:', error);
    }
  };

  const handleDataTableClick = async (dataTableDroppedNodesValue) => {
    console.log('DataTable Grid clicked!');
    const dataTableDroppedNodes = dataTableDroppedNodesValue;
    console.log(JSON.stringify(dataTableDroppedNodes) + "dataTableDroppedNodes");
    console.log();
    sqlJsonDataFileSave(sqlJsonData, gridData);
    navigate('/TableGrid', {
      state: {
        gridData, gridDataColumns,
        nodeData, dataTableDroppedNodes,
        connectionNameValue, connectionTypeValue, reportName,
        dropdownCatalogs,
        dropdownSchemas,
        dropdownTables, dropdownColumns
      }
    });
  };

  const handleBarClick = () => {
    console.log('Bar chart clicked!');
    console.log(JSON.stringify(selectedCombinedBarColumns) + "selectedCombinedBarColumns");
    console.log(JSON.stringify(verticalLabel) + "verticalLabel");
    console.log(JSON.stringify(horizantalLabel) + "horizantalLabel");
    console.log(JSON.stringify(barRightList) + "barRightList");
    sqlJsonDataFileSave(sqlJsonData, gridData);

    navigate('/barChart', {
      state: {
        gridData,
        selectedCombinedBarColumns, verticalLabel, horizantalLabel, barRightList,
        connectionNameValue, reportName, catalogs, schemas, tables, columns, xandLabelBarColumns
      }
    });

  };

  const handleLineClick = () => {
    console.log('Line chart clicked!');
    console.log(JSON.stringify(selectedCombinedLineColumns) + "selectedCombinedLineColumns");
    console.log(JSON.stringify(verticalLineLabel) + "verticalLineLabel");
    console.log(JSON.stringify(horizantalLineLabel) + "horizantalLineLabel");
    console.log(JSON.stringify(lineRightList) + "lineRightList");
    sqlJsonDataFileSave(sqlJsonData, gridData);
    navigate('/lineChart', {
      state: {
        gridData,
        selectedCombinedLineColumns, verticalLineLabel, horizantalLineLabel, lineRightList,
        connectionNameValue, reportName, catalogs, schemas, tables, columns, xandLabelLineColumns
      }
    });

  };
  const handleScatterClick = () => {
    console.log('Scatter chart clicked!');
    console.log(JSON.stringify(selectedCombinedScatterColumns) + "selectedCombinedScatterColumns");
    console.log(JSON.stringify(verticalScatterLabel) + "verticalScatterLabel");
    console.log(JSON.stringify(horizantalScatterLabel) + "horizantalScatterLabel");
    console.log(JSON.stringify(scatterRightList) + "scatterRightList");
    sqlJsonDataFileSave(sqlJsonData, gridData);
    navigate('/scatterChart', {
      state: {
        gridData,
        selectedCombinedScatterColumns, verticalScatterLabel, horizantalScatterLabel, scatterRightList,
        connectionNameValue, reportName, catalogs, schemas, tables, columns, xandLabelScatterColumns
      }
    });

  };

  const handleCancel = () => {
    // Reset the newArray to an empty array
    // setNewArray([]);
    navigate('/ReportDetails', { state: { connectionName: eachReportDetails.connectionName, connectionType: connectionTypeValue } });
  };
  const NodePopup = () => {
    // Render the popup window with the details of the selectedNode
    // You can use any UI component or CSS for styling
    return (
      <div>
        <h2>{selectedNode ? selectedNode.data.label : ''}</h2>
        {/* Other node details */}
      </div>
    );
  };

  const getEdgeStyle = (edgeId) => {

    if (edgeId === selectedEdgeId) {

      return { stroke: 'red' }; // Apply red color to selected edge
    }
    return {}; // Return empty style for non-selected edges
  };
  const updatedEdges = edges.map((edge) => {
    return {
      ...edge,
      style: getEdgeStyle(edge.id),
    };
  });
  const edgeTypes = {
    customEdge: (props) => <CustomEdge {...props} initialEdgeType={props.initialEdgeType}
      onToggle={handleToggleValue} key={id} id={props.id} onButtonValueChange={handleButtonValueChange}
    />,

  };
 
  const handleQueryChange = (event) => {
    //setSqlQuery(event.target.value);
    const queryStr = event.target.value;
    console.log("event::1", `Query:${queryStr}`)
    setSqlDirectQuery(`Query:${queryStr}`);
  };
  
  const handleExecSql = () => {
    console.log("In handleExecSql::1")
    //setSqlDirectQuery(`Query:${queryStr}`);
    execSqlStatement = true;
    handleShow();

  };

  const handleNavigateToLlm = () => {
    const url = '/LlmChat'; // The route you want to open in a new window
    const queryParams = new URLSearchParams(connections).toString(); // Convert state to query parameters
    window.open(`${url}?${queryParams}`, '_blank', 'noopener,noreferrer');
};

  

  const proOptions = { hideAttribution: true };

  return (
    <div>
      <Navbar></Navbar>
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}
      <div>
        {/* Use the Link component with "to" prop to navigate to the home page */}
        Back to :
        <Link to="/ReportDetails" state={{ connectionName: connectionNameValue, connectionType: connectionTypeValue }}>Home</Link>
      </div>
      <h2>{connectionNameValue}</h2>
      <form>
        <div className="dndflow">

          <div>

            <label className="my-label">
              Name:

            </label>
            <input type="text" className="my-input form-control"
              value={reportName}

              onChange={handleReportNameChange} required />
          </div>
          <div >
            <label className="my-label">
              Description:

            </label>
            <textarea className="my-input form-control"
              value={reportDescription}
              onChange={handleReportDescriptionChange}
            />
          </div>
          
          <div className="container">
            <div className="left-container">
              <Sidebar />
            </div>

            <div className="right-container">
              {reportName !== '' ? (
                <ReactFlowProvider>
                  <EdgeProvider>
                    <div className="reactflow-wrapper" ref={reactFlowWrapper}>
                
                      <ReactFlow
                        gridData={gridData}
                        onElementsRemove={onNodesDelete}
                        proOptions={proOptions}
                        onNodeDoubleClick={handleNodeDoubleClick}
                        edgeTypes={edgeTypes}
                        nodes={nodes}
                        edges={edges}
                        droppedNodes={droppedNodes}
                        setNodes={setNodes}
                        setEdges={setEdges}
                        setDroppedNodes={setDroppedNodes}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        onConnect={onConnect}
                        onInit={setReactFlowInstance}
                        onDrop={onDrop}
                        onDragOver={onDragOver}
                        elements={[...nodes, ...updatedEdges]}
                        onElementsRemove={handleElementsRemove}
                        //   onSelectionChange={handleSelectionChange}
                        onNodeClick={handleNodeClick}
                        onEdgeClick={(event, edge) => {
                          handleEdgeClick(edge.id);
                        }}
                        //  edgeStyle={getEdgeStyle} // Apply the style to edges
                        nodeData={nodeData}
                        setNodeData={setNodeData}

                        //  initialEdgeType="AND"
                        fitView

                      >
                      </ReactFlow>

                      {showPopup && popupContent}
                      {showErrorPopup && (
                        <div className="overlay">
                          <div className="errorpopup-window">
                            <div className="error-message">{error}</div>
                            <button className="close-button" onClick={() => setShowErrorPopup(false)}>
                              Close
                            </button>
                          </div>
                        </div>
                      )}

                    </div>
                  </EdgeProvider>
                </ReactFlowProvider>
              ) : (
                <p className='empty-report-message'>Please fill the report name </p>
              
            )}
            </div>

          </div>

          <div style={{ display: 'flex', justifyContent: 'center', paddingLeft: '100px' }}>

            <textarea
              value={sqlQuery}
              rows={10} // Adjust the number of rows as needed
              style={{ width: '50%', minHeight: '50px', resize: 'vertical' }} // Adjust the style as needed
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', paddingLeft: '100px' }}>
          <textarea
            onChange={handleQueryChange}
            readOnly={false}
            rows={10} // Adjust the number of rows as needed
            style={{ width: '50%', minHeight: '150px', resize: 'vertical' }} // Adjust the style as needed
          />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', paddingLeft: '100px' }}>
          <button className="btn btn-success" type="button" onClick={handleExecSql}>Execute SQl</button>
          <button className="btn btn-default" type="button" onClick={handleNavigateToLlm}>Ask LLM</button>
          </div>
          {formDataTableSubmitted && showCharts && !formSubmitted
            && !formBarSubmitted && !formLineSubmitted && !formScatterSubmitted && (
              <TableGrid nodeData={nodeData}
                dataTableDroppedNodes={dataTableDroppedNodes}
                connectionNameValue={connectionNameValue}
                connectionTypeValue={connectionTypeValue}
                reportName={reportName}
                gridData={gridData}
                gridDataColumns={gridDataColumns}
                catalogs={dropdownCatalogs}
                schemas={dropdownSchemas}
                tables={dropdownTables}
                columns={dropdownColumns} />
            )

          }

          {formSubmitted && showCharts && !formDataTableSubmitted && (
            <div>
              <PieChart gridData={gridData}
                twoTableColumnsCombined={twoTableColumnsCombined}
                selectedCombinedColumns={selectedCombinedColumns}
                selectedIdsCombinedColumns={selectedIdsCombinedColumns}
                selectedLabelType={selectedLabelType}
                connectionNameValue={connectionNameValue}
                reportName={reportName}
                indexPie={indexPie}
                xandLabelPieColumns={xandLabelPieColumns}
              />

            </div>
          )}
          {formBarSubmitted && showCharts && !formDataTableSubmitted && (
            <div>
              <BarChart gridData={gridData}
                selectedCombinedBarColumns={selectedCombinedBarColumns}
                verticalLabel={verticalLabel}
                horizantalLabel={horizantalLabel}
                barRightList={barRightList}
                connectionNameValue={connectionNameValue}
                reportName={reportName}
                catalogs={catalogs}
                schemas={schemas}
                tables={tables}
                columns={columns}
                xandLabelBarColumns={xandLabelBarColumns} />

            </div>
          )}
          {formLineSubmitted && showCharts && !formDataTableSubmitted && (
            <div>
              <LineChart gridData={gridData}
                selectedCombinedLineColumns={selectedCombinedLineColumns}
                verticalLineLabel={verticalLineLabel}
                horizantalLineLabel={horizantalLineLabel}
                lineRightList={lineRightList}
                connectionNameValue={connectionNameValue}
                reportName={reportName}
                catalogs={catalogs}
                schemas={schemas}
                tables={tables}
                columns={columns}
                xandLabelLineColumns={xandLabelLineColumns} />
            </div>
          )}
          {formScatterSubmitted && showCharts && !formDataTableSubmitted && (
            <div>
              <ScatterChart
                gridData={gridData}
                selectedCombinedScatterColumns={selectedCombinedScatterColumns}
                verticalScatterLabel={verticalScatterLabel}
                horizantalScatterLabel={horizantalScatterLabel}
                scatterRightList={scatterRightList}
                connectionNameValue={connectionNameValue}
                reportName={reportName}
                catalogs={catalogs}
                schemas={schemas}
                tables={tables}
                columns={columns}
                xandLabelScatterColumns={xandLabelScatterColumns} />
            </div>
          )}
          {formBoxWhiskerSubmitted && showCharts && !formDataTableSubmitted && (
            <div>
              <BoxWhiskerChart selectedCombinedBoxWhiskerColumns={selectedCombinedBoxWhiskerColumns}
                verticalBoxWhiskerLabel={verticalBoxWhiskerLabel}
                horizantalBoxWhiskerLabel={horizantalBoxWhiskerLabel}
                boxWhiskerRightList={boxWhiskerRightList}
                connectionNameValue={connectionNameValue}
                reportName={reportName} />
            </div>
          )}
          <div className="create-cancel">
            <button className="btn btn-success" type="button" onClick={handleCreate}>Save</button>
            <button className="btn btn-success" type="button" onClick={handleShow}>Show</button>
            <button className="btn btn-success" type="button" onClick={handlePublish}>Publish</button>
            <button className="btn btn-default" type="button" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </form>
    </div>
  );
};



export default QueryBuilder;

